var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272.697,
    height: 174.461,
    viewBox: "0 0 272.697 174.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration_",
    "data-name": "Illustration ",
    transform: "translate(-24.825 -36.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-62",
    transform: "translate(24.825 36.283)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204092",
    "data-name": "Rectangle 204092",
    width: 12.396,
    height: 52.412,
    transform: "translate(26.982 174.203) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204093",
    "data-name": "Rectangle 204093",
    width: 3.768,
    height: 7.261,
    transform: "translate(24.675 132.721) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510442",
    "data-name": "Path 510442",
    d: "M80.019,349.2c.029,0,.049-1.642.049-3.628s0-3.633-.049-3.633-.049,1.642-.049,3.633S79.982,349.2,80.019,349.2Z",
    transform: "translate(-57.335 -216.48)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510443",
    "data-name": "Path 510443",
    d: "M75.76,348a18.561,18.561,0,0,0,1.884.049A18.561,18.561,0,0,0,79.528,348a16.921,16.921,0,0,0-1.884-.053A16.848,16.848,0,0,0,75.76,348Z",
    transform: "translate(-54.853 -220.019)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510444",
    "data-name": "Path 510444",
    d: "M75.71,354.33a17.869,17.869,0,0,0,1.9.049,17.808,17.808,0,0,0,1.9-.049,17.808,17.808,0,0,0-1.9-.049A17.853,17.853,0,0,0,75.71,354.33Z",
    transform: "translate(-54.824 -223.751)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204094",
    "data-name": "Rectangle 204094",
    width: 3.768,
    height: 7.261,
    transform: "translate(24.675 142.203) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510445",
    "data-name": "Path 510445",
    d: "M80.019,372.3c.029,0,.049-1.642.049-3.628s0-3.633-.049-3.633-.049,1.642-.049,3.633S79.982,372.3,80.019,372.3Z",
    transform: "translate(-57.335 -230.098)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510446",
    "data-name": "Path 510446",
    d: "M75.76,371.1a17.53,17.53,0,0,0,1.884.049,17.594,17.594,0,0,0,1.884-.049,16.921,16.921,0,0,0-1.884-.053A16.848,16.848,0,0,0,75.76,371.1Z",
    transform: "translate(-54.853 -233.638)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510447",
    "data-name": "Path 510447",
    d: "M75.71,377.43a17.157,17.157,0,0,0,1.9.053,17.113,17.113,0,0,0,1.9-.053,17.808,17.808,0,0,0-1.9-.049A17.869,17.869,0,0,0,75.71,377.43Z",
    transform: "translate(-54.824 -237.369)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204095",
    "data-name": "Rectangle 204095",
    width: 3.768,
    height: 7.261,
    transform: "translate(24.675 151.685) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510448",
    "data-name": "Path 510448",
    d: "M80.035,395.4c.029,0,.049-1.642.049-3.628s0-3.633-.049-3.633S80,389.765,80,391.777,80,395.4,80.035,395.4Z",
    transform: "translate(-57.351 -243.716)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510449",
    "data-name": "Path 510449",
    d: "M75.76,394.21a17.538,17.538,0,0,0,1.884.049,17.61,17.61,0,0,0,1.884-.049,17.594,17.594,0,0,0-1.884-.049,17.546,17.546,0,0,0-1.884.049Z",
    transform: "translate(-54.853 -247.262)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510450",
    "data-name": "Path 510450",
    d: "M75.71,400.539a17.164,17.164,0,0,0,1.9.053,17.113,17.113,0,0,0,1.9-.053c0-.025-.85-.049-1.9-.049S75.71,400.515,75.71,400.539Z",
    transform: "translate(-54.824 -250.997)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204096",
    "data-name": "Rectangle 204096",
    width: 3.768,
    height: 7.261,
    transform: "translate(24.675 161.166) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510451",
    "data-name": "Path 510451",
    d: "M80.035,418.507c.029,0,.049-1.642.049-3.629s0-3.628-.049-3.628S80,412.871,80,414.878,80,418.507,80.035,418.507Z",
    transform: "translate(-57.351 -257.34)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510452",
    "data-name": "Path 510452",
    d: "M75.76,417.31a17.538,17.538,0,0,0,1.884.049,17.594,17.594,0,0,0,1.884-.049,17.6,17.6,0,0,0-1.884-.049,17.538,17.538,0,0,0-1.884.049Z",
    transform: "translate(-54.853 -260.88)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510453",
    "data-name": "Path 510453",
    d: "M75.71,423.639a17.164,17.164,0,0,0,1.9.053,17.113,17.113,0,0,0,1.9-.053c0-.025-.85-.049-1.9-.049S75.71,423.615,75.71,423.639Z",
    transform: "translate(-54.824 -264.615)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204097",
    "data-name": "Rectangle 204097",
    width: 9.03,
    height: 52.412,
    transform: "translate(18.35 174.203) rotate(180)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204098",
    "data-name": "Rectangle 204098",
    width: 3.768,
    height: 7.261,
    transform: "translate(15.542 132.721) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510454",
    "data-name": "Path 510454",
    d: "M57.779,349.2c.029,0,.049-1.642.049-3.628s0-3.633-.049-3.633-.049,1.642-.049,3.633S57.751,349.2,57.779,349.2Z",
    transform: "translate(-44.224 -216.48)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510455",
    "data-name": "Path 510455",
    d: "M53.52,348a18.561,18.561,0,0,0,1.884.049A18.561,18.561,0,0,0,57.288,348a16.921,16.921,0,0,0-1.884-.053A16.847,16.847,0,0,0,53.52,348Z",
    transform: "translate(-41.742 -220.019)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510456",
    "data-name": "Path 510456",
    d: "M53.47,354.33a17.853,17.853,0,0,0,1.9.049,17.808,17.808,0,0,0,1.9-.049,17.808,17.808,0,0,0-1.9-.049,17.853,17.853,0,0,0-1.9.049Z",
    transform: "translate(-41.712 -223.751)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204099",
    "data-name": "Rectangle 204099",
    width: 3.768,
    height: 7.261,
    transform: "translate(15.542 142.281) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510457",
    "data-name": "Path 510457",
    d: "M57.779,372.491c.029,0,.049-1.642.049-3.628s0-3.633-.049-3.633-.049,1.642-.049,3.633S57.751,372.491,57.779,372.491Z",
    transform: "translate(-44.224 -230.21)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510458",
    "data-name": "Path 510458",
    d: "M53.52,371.294a18.566,18.566,0,0,0,1.884.049,18.566,18.566,0,0,0,1.884-.049,16.928,16.928,0,0,0-1.884-.053A16.862,16.862,0,0,0,53.52,371.294Z",
    transform: "translate(-41.742 -233.75)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510459",
    "data-name": "Path 510459",
    d: "M53.47,377.62a17.861,17.861,0,0,0,1.9.049,17.808,17.808,0,0,0,1.9-.049,17.8,17.8,0,0,0-1.9-.049,17.853,17.853,0,0,0-1.9.049Z",
    transform: "translate(-41.712 -237.481)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204100",
    "data-name": "Rectangle 204100",
    width: 3.768,
    height: 7.261,
    transform: "translate(15.542 151.841) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510460",
    "data-name": "Path 510460",
    d: "M57.779,395.781c.029,0,.049-1.642.049-3.628s0-3.633-.049-3.633-.049,1.642-.049,3.633S57.751,395.781,57.779,395.781Z",
    transform: "translate(-44.224 -243.94)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510461",
    "data-name": "Path 510461",
    d: "M53.52,394.59a17.53,17.53,0,0,0,1.884.049,17.594,17.594,0,0,0,1.884-.049,17.594,17.594,0,0,0-1.884-.049A17.53,17.53,0,0,0,53.52,394.59Z",
    transform: "translate(-41.742 -247.486)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510462",
    "data-name": "Path 510462",
    d: "M53.47,400.92a17.157,17.157,0,0,0,1.9.053,17.112,17.112,0,0,0,1.9-.053,17.792,17.792,0,0,0-1.9-.049,17.853,17.853,0,0,0-1.9.049Z",
    transform: "translate(-41.712 -251.217)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204101",
    "data-name": "Rectangle 204101",
    width: 3.768,
    height: 7.261,
    transform: "translate(15.542 161.4) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510463",
    "data-name": "Path 510463",
    d: "M57.779,419.071c.029,0,.049-1.642.049-3.628s0-3.633-.049-3.633-.049,1.642-.049,3.633S57.751,419.071,57.779,419.071Z",
    transform: "translate(-44.224 -257.671)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510464",
    "data-name": "Path 510464",
    d: "M53.52,417.92a17.514,17.514,0,0,0,1.884.049,17.586,17.586,0,0,0,1.884-.049,17.6,17.6,0,0,0-1.884-.049A17.538,17.538,0,0,0,53.52,417.92Z",
    transform: "translate(-41.742 -261.24)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510465",
    "data-name": "Path 510465",
    d: "M53.47,424.209a17.164,17.164,0,0,0,1.9.053,17.105,17.105,0,0,0,1.9-.053c0-.025-.85-.049-1.9-.049S53.47,424.185,53.47,424.209Z",
    transform: "translate(-41.712 -264.951)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204102",
    "data-name": "Rectangle 204102",
    width: 3.768,
    height: 7.261,
    transform: "translate(24.675 170.648) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510466",
    "data-name": "Path 510466",
    d: "M80.019,441.577c.029,0,.049-1.642.049-3.628s0-3.629-.049-3.629-.049,1.642-.049,3.629S79.982,441.577,80.019,441.577Z",
    transform: "translate(-57.335 -270.941)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510467",
    "data-name": "Path 510467",
    d: "M75.76,440.41a17.538,17.538,0,0,0,1.884.049,17.61,17.61,0,0,0,1.884-.049,17.6,17.6,0,0,0-1.884-.049,17.546,17.546,0,0,0-1.884.049Z",
    transform: "translate(-54.853 -274.498)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510468",
    "data-name": "Path 510468",
    d: "M75.71,446.734c0,.025.85.049,1.9.049s1.9-.025,1.9-.049a17.1,17.1,0,0,0-1.9-.053A17.149,17.149,0,0,0,75.71,446.734Z",
    transform: "translate(-54.824 -278.224)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204103",
    "data-name": "Rectangle 204103",
    width: 3.768,
    height: 7.261,
    transform: "translate(15.542 170.964) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510469",
    "data-name": "Path 510469",
    d: "M57.779,442.361c.029,0,.049-1.642.049-3.628s0-3.633-.049-3.633-.049,1.642-.049,3.633S57.751,442.361,57.779,442.361Z",
    transform: "translate(-44.224 -271.401)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510470",
    "data-name": "Path 510470",
    d: "M53.52,441.17a17.538,17.538,0,0,0,1.884.049,17.61,17.61,0,0,0,1.884-.049,17.594,17.594,0,0,0-1.884-.049A17.53,17.53,0,0,0,53.52,441.17Z",
    transform: "translate(-41.742 -274.946)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510471",
    "data-name": "Path 510471",
    d: "M53.47,447.5a17.157,17.157,0,0,0,1.9.053,17.12,17.12,0,0,0,1.9-.053c0-.025-.85-.049-1.9-.049S53.47,447.475,53.47,447.5Z",
    transform: "translate(-41.712 -278.682)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204104",
    "data-name": "Rectangle 204104",
    width: 14.584,
    height: 61.668,
    transform: "translate(161.388 137.294) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204105",
    "data-name": "Rectangle 204105",
    width: 4.433,
    height: 8.542,
    transform: "translate(158.666 88.49) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510472",
    "data-name": "Path 510472",
    d: "M405.592,239.6c.033,0,.057-1.913.057-4.269s-.025-4.273-.057-4.273-.062,1.913-.062,4.273S405.559,239.6,405.592,239.6Z",
    transform: "translate(-249.265 -151.112)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510473",
    "data-name": "Path 510473",
    d: "M400.58,238.207a39.92,39.92,0,0,0,4.433,0A42.77,42.77,0,0,0,400.58,238.207Z",
    transform: "translate(-246.347 -155.291)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510474",
    "data-name": "Path 510474",
    d: "M400.52,245.647a40.6,40.6,0,0,0,4.47,0,43.511,43.511,0,0,0-4.47,0Z",
    transform: "translate(-246.311 -159.678)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204106",
    "data-name": "Rectangle 204106",
    width: 4.433,
    height: 8.542,
    transform: "translate(158.666 99.646) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510475",
    "data-name": "Path 510475",
    d: "M405.592,266.782c.033,0,.057-1.913.057-4.269s-.025-4.273-.057-4.273-.062,1.913-.062,4.273S405.559,266.782,405.592,266.782Z",
    transform: "translate(-249.265 -167.135)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510476",
    "data-name": "Path 510476",
    d: "M400.58,265.387a39.913,39.913,0,0,0,4.433,0A42.787,42.787,0,0,0,400.58,265.387Z",
    transform: "translate(-246.347 -171.315)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510477",
    "data-name": "Path 510477",
    d: "M400.52,272.827a40.6,40.6,0,0,0,4.47,0,43.511,43.511,0,0,0-4.47,0Z",
    transform: "translate(-246.311 -175.701)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204107",
    "data-name": "Rectangle 204107",
    width: 4.433,
    height: 8.542,
    transform: "translate(158.666 110.803) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510478",
    "data-name": "Path 510478",
    d: "M405.592,293.962c.033,0,.057-1.913.057-4.269s-.025-4.273-.057-4.273-.062,1.913-.062,4.273S405.559,293.962,405.592,293.962Z",
    transform: "translate(-249.265 -183.159)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510479",
    "data-name": "Path 510479",
    d: "M400.58,292.567a42.786,42.786,0,0,0,4.433,0A42.752,42.752,0,0,0,400.58,292.567Z",
    transform: "translate(-246.347 -187.339)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510480",
    "data-name": "Path 510480",
    d: "M400.52,300.008a40.611,40.611,0,0,0,4.47,0A43.5,43.5,0,0,0,400.52,300.008Z",
    transform: "translate(-246.311 -191.725)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204108",
    "data-name": "Rectangle 204108",
    width: 4.433,
    height: 8.542,
    transform: "translate(158.666 121.959) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510481",
    "data-name": "Path 510481",
    d: "M405.592,321.142c.033,0,.057-1.913.057-4.273s-.025-4.269-.057-4.269-.062,1.913-.062,4.269S405.559,321.142,405.592,321.142Z",
    transform: "translate(-249.265 -199.183)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510482",
    "data-name": "Path 510482",
    d: "M400.58,319.747a42.778,42.778,0,0,0,4.433,0,42.77,42.77,0,0,0-4.433,0Z",
    transform: "translate(-246.347 -203.362)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510483",
    "data-name": "Path 510483",
    d: "M400.52,327.187a40.589,40.589,0,0,0,4.47,0A43.529,43.529,0,0,0,400.52,327.187Z",
    transform: "translate(-246.311 -207.749)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204109",
    "data-name": "Rectangle 204109",
    width: 10.623,
    height: 61.668,
    transform: "translate(151.224 137.294) rotate(180)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204110",
    "data-name": "Rectangle 204110",
    width: 4.433,
    height: 8.542,
    transform: "translate(147.928 88.49) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510484",
    "data-name": "Path 510484",
    d: "M379.427,239.6c.033,0,.057-1.913.057-4.269s-.025-4.273-.057-4.273-.057,1.913-.057,4.273S379.395,239.6,379.427,239.6Z",
    transform: "translate(-233.843 -151.112)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510485",
    "data-name": "Path 510485",
    d: "M374.41,238.207a39.921,39.921,0,0,0,4.433,0,42.77,42.77,0,0,0-4.433,0Z",
    transform: "translate(-230.919 -155.291)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510486",
    "data-name": "Path 510486",
    d: "M374.36,245.647a40.521,40.521,0,0,0,4.466,0A43.414,43.414,0,0,0,374.36,245.647Z",
    transform: "translate(-230.889 -159.678)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204111",
    "data-name": "Rectangle 204111",
    width: 4.433,
    height: 8.542,
    transform: "translate(147.928 99.737) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510487",
    "data-name": "Path 510487",
    d: "M379.427,267.008c.033,0,.057-1.913.057-4.269s-.025-4.269-.057-4.269-.057,1.909-.057,4.269S379.395,267.008,379.427,267.008Z",
    transform: "translate(-233.843 -167.271)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510488",
    "data-name": "Path 510488",
    d: "M374.41,265.607a39.928,39.928,0,0,0,4.433,0,42.787,42.787,0,0,0-4.433,0Z",
    transform: "translate(-230.919 -171.445)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510489",
    "data-name": "Path 510489",
    d: "M374.36,273.052a43.406,43.406,0,0,0,4.466,0A40.529,40.529,0,0,0,374.36,273.052Z",
    transform: "translate(-230.889 -175.831)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204112",
    "data-name": "Rectangle 204112",
    width: 4.433,
    height: 8.542,
    transform: "translate(147.928 110.983) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510490",
    "data-name": "Path 510490",
    d: "M379.427,294.408c.033,0,.057-1.909.057-4.269s-.025-4.269-.057-4.269-.057,1.909-.057,4.269S379.395,294.408,379.427,294.408Z",
    transform: "translate(-233.843 -183.424)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510491",
    "data-name": "Path 510491",
    d: "M374.41,293.012a42.77,42.77,0,0,0,4.433,0A39.936,39.936,0,0,0,374.41,293.012Z",
    transform: "translate(-230.919 -187.598)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510492",
    "data-name": "Path 510492",
    d: "M374.36,300.452a43.414,43.414,0,0,0,4.466,0A40.514,40.514,0,0,0,374.36,300.452Z",
    transform: "translate(-230.889 -191.984)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204113",
    "data-name": "Rectangle 204113",
    width: 4.433,
    height: 8.542,
    transform: "translate(147.928 122.234) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510493",
    "data-name": "Path 510493",
    d: "M379.427,321.812c.033,0,.057-1.913.057-4.273s-.025-4.269-.057-4.269-.057,1.913-.057,4.269S379.395,321.812,379.427,321.812Z",
    transform: "translate(-233.843 -199.578)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510494",
    "data-name": "Path 510494",
    d: "M374.41,320.412a42.787,42.787,0,0,0,4.433,0A39.943,39.943,0,0,0,374.41,320.412Z",
    transform: "translate(-230.919 -203.751)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510495",
    "data-name": "Path 510495",
    d: "M374.36,327.857a43.423,43.423,0,0,0,4.466,0A43.406,43.406,0,0,0,374.36,327.857Z",
    transform: "translate(-230.889 -208.144)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204114",
    "data-name": "Rectangle 204114",
    width: 4.433,
    height: 8.542,
    transform: "translate(158.666 133.115) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510496",
    "data-name": "Path 510496",
    d: "M405.592,348.322c.033,0,.057-1.913.057-4.273s-.025-4.269-.057-4.269-.062,1.913-.062,4.269S405.559,348.322,405.592,348.322Z",
    transform: "translate(-249.265 -215.206)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510497",
    "data-name": "Path 510497",
    d: "M400.58,346.912a42.786,42.786,0,0,0,4.433,0A39.912,39.912,0,0,0,400.58,346.912Z",
    transform: "translate(-246.347 -219.374)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510498",
    "data-name": "Path 510498",
    d: "M400.52,354.367a43.5,43.5,0,0,0,4.47,0,43.5,43.5,0,0,0-4.47,0Z",
    transform: "translate(-246.311 -223.772)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204115",
    "data-name": "Rectangle 204115",
    width: 4.433,
    height: 8.542,
    transform: "translate(147.928 133.481) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510499",
    "data-name": "Path 510499",
    d: "M379.427,349.212c.033,0,.057-1.913.057-4.269s-.025-4.273-.057-4.273-.057,1.913-.057,4.273S379.395,349.212,379.427,349.212Z",
    transform: "translate(-233.843 -215.731)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510500",
    "data-name": "Path 510500",
    d: "M374.41,347.817a39.928,39.928,0,0,0,4.433,0,42.787,42.787,0,0,0-4.433,0Z",
    transform: "translate(-230.919 -219.911)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510501",
    "data-name": "Path 510501",
    d: "M374.36,355.257a40.521,40.521,0,0,0,4.466,0A43.406,43.406,0,0,0,374.36,355.257Z",
    transform: "translate(-230.889 -224.297)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204116",
    "data-name": "Rectangle 204116",
    width: 14.584,
    height: 61.668,
    transform: "translate(161.617 174.199) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204117",
    "data-name": "Rectangle 204117",
    width: 4.433,
    height: 8.542,
    transform: "translate(158.9 125.399) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510502",
    "data-name": "Path 510502",
    d: "M406.157,329.522c.033,0,.062-1.913.062-4.273s-.029-4.269-.062-4.269-.057,1.913-.057,4.269S406.125,329.522,406.157,329.522Z",
    transform: "translate(-249.601 -204.123)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510503",
    "data-name": "Path 510503",
    d: "M401.15,328.122a42.761,42.761,0,0,0,4.433,0,39.927,39.927,0,0,0-4.433,0Z",
    transform: "translate(-246.683 -208.297)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510504",
    "data-name": "Path 510504",
    d: "M401.09,335.567a40.6,40.6,0,0,0,4.47,0A43.5,43.5,0,0,0,401.09,335.567Z",
    transform: "translate(-246.648 -212.689)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204118",
    "data-name": "Rectangle 204118",
    width: 4.433,
    height: 8.542,
    transform: "translate(158.9 136.555) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510505",
    "data-name": "Path 510505",
    d: "M406.157,356.732c.033,0,.062-1.913.062-4.273s-.029-4.269-.062-4.269-.057,1.913-.057,4.269S406.125,356.732,406.157,356.732Z",
    transform: "translate(-249.601 -220.164)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510506",
    "data-name": "Path 510506",
    d: "M401.15,355.3a42.786,42.786,0,0,0,4.433,0A39.912,39.912,0,0,0,401.15,355.3Z",
    transform: "translate(-246.683 -224.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510507",
    "data-name": "Path 510507",
    d: "M401.09,362.747a43.5,43.5,0,0,0,4.47,0,43.519,43.519,0,0,0-4.47,0Z",
    transform: "translate(-246.648 -228.713)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204119",
    "data-name": "Rectangle 204119",
    width: 4.433,
    height: 8.542,
    transform: "translate(158.9 147.712) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510508",
    "data-name": "Path 510508",
    d: "M406.157,383.882c.033,0,.062-1.913.062-4.273s-.029-4.269-.062-4.269-.057,1.913-.057,4.269S406.125,383.882,406.157,383.882Z",
    transform: "translate(-249.601 -236.17)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510509",
    "data-name": "Path 510509",
    d: "M401.15,382.482a42.786,42.786,0,0,0,4.433,0A39.912,39.912,0,0,0,401.15,382.482Z",
    transform: "translate(-246.683 -240.344)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510510",
    "data-name": "Path 510510",
    d: "M401.09,389.912a43.505,43.505,0,0,0,4.478,0,40.588,40.588,0,0,0-4.47,0Z",
    transform: "translate(-246.648 -244.724)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204120",
    "data-name": "Rectangle 204120",
    width: 4.433,
    height: 8.542,
    transform: "translate(158.9 158.864) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510511",
    "data-name": "Path 510511",
    d: "M406.157,411.062c.033,0,.062-1.913.062-4.273s-.029-4.269-.062-4.269-.057,1.913-.057,4.269S406.125,411.062,406.157,411.062Z",
    transform: "translate(-249.601 -252.194)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510512",
    "data-name": "Path 510512",
    d: "M401.15,409.662a42.786,42.786,0,0,0,4.433,0A39.912,39.912,0,0,0,401.15,409.662Z",
    transform: "translate(-246.683 -256.368)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510513",
    "data-name": "Path 510513",
    d: "M401.09,417.1a43.519,43.519,0,0,0,4.47,0A40.58,40.58,0,0,0,401.09,417.1Z",
    transform: "translate(-246.648 -260.754)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204121",
    "data-name": "Rectangle 204121",
    width: 10.627,
    height: 61.668,
    transform: "translate(151.458 174.199) rotate(180)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204122",
    "data-name": "Rectangle 204122",
    width: 4.433,
    height: 8.542,
    transform: "translate(148.158 125.399) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510514",
    "data-name": "Path 510514",
    d: "M379.992,329.522c.033,0,.057-1.913.057-4.273s-.025-4.269-.057-4.269-.062,1.913-.062,4.269S379.959,329.522,379.992,329.522Z",
    transform: "translate(-234.173 -204.123)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510515",
    "data-name": "Path 510515",
    d: "M375,328.122a42.786,42.786,0,0,0,4.433,0A39.927,39.927,0,0,0,375,328.122Z",
    transform: "translate(-231.266 -208.297)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510516",
    "data-name": "Path 510516",
    d: "M374.93,335.567a40.521,40.521,0,0,0,4.466,0,43.414,43.414,0,0,0-4.466,0Z",
    transform: "translate(-231.225 -212.689)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204123",
    "data-name": "Rectangle 204123",
    width: 4.433,
    height: 8.542,
    transform: "translate(148.158 136.645) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510517",
    "data-name": "Path 510517",
    d: "M379.992,356.922c.033,0,.057-1.913.057-4.269s-.025-4.273-.057-4.273-.062,1.913-.062,4.273S379.959,356.922,379.992,356.922Z",
    transform: "translate(-234.173 -220.276)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510518",
    "data-name": "Path 510518",
    d: "M375,355.527a39.942,39.942,0,0,0,4.433,0,42.761,42.761,0,0,0-4.433,0Z",
    transform: "translate(-231.266 -224.456)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510519",
    "data-name": "Path 510519",
    d: "M374.93,362.967a40.506,40.506,0,0,0,4.466,0A43.423,43.423,0,0,0,374.93,362.967Z",
    transform: "translate(-231.225 -228.842)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204124",
    "data-name": "Rectangle 204124",
    width: 4.433,
    height: 8.542,
    transform: "translate(148.158 147.896) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510520",
    "data-name": "Path 510520",
    d: "M379.992,384.322c.033,0,.057-1.913.057-4.269s-.025-4.273-.057-4.273-.062,1.913-.062,4.273S379.959,384.322,379.992,384.322Z",
    transform: "translate(-234.173 -236.43)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510521",
    "data-name": "Path 510521",
    d: "M375,382.917a39.927,39.927,0,0,0,4.433,0A42.769,42.769,0,0,0,375,382.917Z",
    transform: "translate(-231.266 -240.603)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510522",
    "data-name": "Path 510522",
    d: "M374.93,390.372c0,.029,1,.057,2.233.057s2.233-.029,2.233-.057A40.521,40.521,0,0,0,374.93,390.372Z",
    transform: "translate(-231.225 -244.996)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204125",
    "data-name": "Rectangle 204125",
    width: 4.433,
    height: 8.542,
    transform: "translate(148.158 159.139) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510523",
    "data-name": "Path 510523",
    d: "M379.992,411.738c.033,0,.057-1.909.057-4.269s-.025-4.269-.057-4.269-.062,1.909-.062,4.269S379.959,411.738,379.992,411.738Z",
    transform: "translate(-234.173 -252.595)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510524",
    "data-name": "Path 510524",
    d: "M375,410.332a42.786,42.786,0,0,0,4.433,0,39.957,39.957,0,0,0-4.433,0Z",
    transform: "translate(-231.266 -256.763)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510525",
    "data-name": "Path 510525",
    d: "M374.93,417.772a43.423,43.423,0,0,0,4.466,0A40.521,40.521,0,0,0,374.93,417.772Z",
    transform: "translate(-231.225 -261.149)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204126",
    "data-name": "Rectangle 204126",
    width: 4.433,
    height: 8.542,
    transform: "translate(158.9 170.02) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510526",
    "data-name": "Path 510526",
    d: "M406.157,438.238c.033,0,.062-1.909.062-4.269s-.029-4.269-.062-4.269-.057,1.909-.057,4.269S406.125,438.238,406.157,438.238Z",
    transform: "translate(-249.601 -268.217)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510527",
    "data-name": "Path 510527",
    d: "M401.15,436.842a42.769,42.769,0,0,0,4.433,0A39.942,39.942,0,0,0,401.15,436.842Z",
    transform: "translate(-246.683 -272.391)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510528",
    "data-name": "Path 510528",
    d: "M401.09,444.282a43.5,43.5,0,0,0,4.47,0,40.6,40.6,0,0,0-4.47,0Z",
    transform: "translate(-246.648 -276.778)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204127",
    "data-name": "Rectangle 204127",
    width: 4.433,
    height: 8.542,
    transform: "translate(148.158 170.39) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510529",
    "data-name": "Path 510529",
    d: "M379.992,439.132c.033,0,.057-1.913.057-4.273s-.025-4.269-.057-4.269-.062,1.913-.062,4.269S379.959,439.132,379.992,439.132Z",
    transform: "translate(-234.173 -268.742)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510530",
    "data-name": "Path 510530",
    d: "M375,437.732a42.769,42.769,0,0,0,4.433,0A39.927,39.927,0,0,0,375,437.732Z",
    transform: "translate(-231.266 -272.916)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510531",
    "data-name": "Path 510531",
    d: "M374.93,445.177a43.423,43.423,0,0,0,4.466,0A43.405,43.405,0,0,0,374.93,445.177Z",
    transform: "translate(-231.225 -277.308)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204128",
    "data-name": "Rectangle 204128",
    width: 21.779,
    height: 97.538,
    transform: "translate(54.323 174.112) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204129",
    "data-name": "Rectangle 204129",
    width: 6.621,
    height: 12.757,
    transform: "translate(50.263 95.788) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510532",
    "data-name": "Path 510532",
    d: "M138.636,251.327c.049,0,.09-2.873.09-6.379s-.041-6.379-.09-6.379-.086,2.873-.086,6.379S138.587,251.327,138.636,251.327Z",
    transform: "translate(-91.87 -155.539)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510533",
    "data-name": "Path 510533",
    d: "M131.15,249.224a31.324,31.324,0,0,0,3.312.086,31.279,31.279,0,0,0,3.308-.086,30.586,30.586,0,0,0-3.308-.09A30.622,30.622,0,0,0,131.15,249.224Z",
    transform: "translate(-87.508 -161.76)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510534",
    "data-name": "Path 510534",
    d: "M131.07,260.34a31.1,31.1,0,0,0,3.337.09,31.1,31.1,0,0,0,3.337-.09,31.825,31.825,0,0,0-3.337-.086A31.824,31.824,0,0,0,131.07,260.34Z",
    transform: "translate(-87.46 -168.316)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204130",
    "data-name": "Rectangle 204130",
    width: 6.621,
    height: 12.757,
    transform: "translate(50.263 112.453) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510535",
    "data-name": "Path 510535",
    d: "M138.636,291.917c.049,0,.09-2.873.09-6.379s-.041-6.379-.09-6.379-.086,2.873-.086,6.379S138.587,291.917,138.636,291.917Z",
    transform: "translate(-91.87 -179.468)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510536",
    "data-name": "Path 510536",
    d: "M131.15,289.86a30.638,30.638,0,0,0,3.312.09,30.578,30.578,0,0,0,3.308-.09,31.287,31.287,0,0,0-3.308-.086A31.34,31.34,0,0,0,131.15,289.86Z",
    transform: "translate(-87.508 -185.719)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510537",
    "data-name": "Path 510537",
    d: "M131.07,300.934a33.238,33.238,0,0,0,3.337.086,33.239,33.239,0,0,0,3.337-.086,31.1,31.1,0,0,0-3.337-.09A31.1,31.1,0,0,0,131.07,300.934Z",
    transform: "translate(-87.46 -192.245)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204131",
    "data-name": "Rectangle 204131",
    width: 6.621,
    height: 12.757,
    transform: "translate(50.263 129.113) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510538",
    "data-name": "Path 510538",
    d: "M138.636,332.517c.049,0,.09-2.873.09-6.379s-.041-6.379-.09-6.379-.086,2.853-.086,6.379S138.587,332.517,138.636,332.517Z",
    transform: "translate(-91.87 -203.404)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510539",
    "data-name": "Path 510539",
    d: "M131.15,330.414a32.705,32.705,0,0,0,3.312.086,32.66,32.66,0,0,0,3.308-.086,30.578,30.578,0,0,0-3.308-.09A30.63,30.63,0,0,0,131.15,330.414Z",
    transform: "translate(-87.508 -209.625)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510540",
    "data-name": "Path 510540",
    d: "M131.07,341.524a31.1,31.1,0,0,0,3.337.09,31.111,31.111,0,0,0,3.337-.09,31.1,31.1,0,0,0-3.337-.09A31.11,31.11,0,0,0,131.07,341.524Z",
    transform: "translate(-87.46 -216.175)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204132",
    "data-name": "Rectangle 204132",
    width: 6.621,
    height: 12.757,
    transform: "translate(50.263 145.774) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510541",
    "data-name": "Path 510541",
    d: "M138.636,373.107c.049,0,.09-2.873.09-6.379s-.041-6.379-.09-6.379-.086,2.873-.086,6.379S138.587,373.107,138.636,373.107Z",
    transform: "translate(-91.87 -227.333)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510542",
    "data-name": "Path 510542",
    d: "M131.15,371a30.614,30.614,0,0,0,3.312.09,30.578,30.578,0,0,0,3.308-.09,30.578,30.578,0,0,0-3.308-.09A30.614,30.614,0,0,0,131.15,371Z",
    transform: "translate(-87.508 -233.554)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510543",
    "data-name": "Path 510543",
    d: "M131.07,382.122a31.1,31.1,0,0,0,3.337.09,31.111,31.111,0,0,0,3.337-.09,33.23,33.23,0,0,0-3.337-.086A33.229,33.229,0,0,0,131.07,382.122Z",
    transform: "translate(-87.46 -240.112)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204133",
    "data-name": "Rectangle 204133",
    width: 15.868,
    height: 97.538,
    transform: "translate(39.152 174.112) rotate(180)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204134",
    "data-name": "Rectangle 204134",
    width: 6.621,
    height: 12.757,
    transform: "translate(34.222 95.788) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510544",
    "data-name": "Path 510544",
    d: "M99.556,251.327c.049,0,.09-2.873.09-6.379s-.041-6.379-.09-6.379-.086,2.873-.086,6.379S99.507,251.327,99.556,251.327Z",
    transform: "translate(-68.831 -155.539)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510545",
    "data-name": "Path 510545",
    d: "M92.07,249.224a31.279,31.279,0,0,0,3.308.086,31.324,31.324,0,0,0,3.312-.086,30.622,30.622,0,0,0-3.312-.09,30.57,30.57,0,0,0-3.308.09Z",
    transform: "translate(-64.468 -161.76)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510546",
    "data-name": "Path 510546",
    d: "M92,260.34a31.1,31.1,0,0,0,3.337.09,31.1,31.1,0,0,0,3.337-.09,31.824,31.824,0,0,0-3.337-.086A31.824,31.824,0,0,0,92,260.34Z",
    transform: "translate(-64.427 -168.316)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204135",
    "data-name": "Rectangle 204135",
    width: 6.621,
    height: 12.757,
    transform: "translate(34.222 112.584) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510547",
    "data-name": "Path 510547",
    d: "M99.556,292.257c.049,0,.09-2.873.09-6.379s-.041-6.379-.09-6.379-.086,2.853-.086,6.379S99.507,292.257,99.556,292.257Z",
    transform: "translate(-68.831 -179.669)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510548",
    "data-name": "Path 510548",
    d: "M92.07,290.152a30.57,30.57,0,0,0,3.308.09,30.614,30.614,0,0,0,3.312-.09,32.714,32.714,0,0,0-3.312-.086A32.66,32.66,0,0,0,92.07,290.152Z",
    transform: "translate(-64.468 -185.892)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510549",
    "data-name": "Path 510549",
    d: "M92,301.264a31.824,31.824,0,0,0,3.337.086,31.824,31.824,0,0,0,3.337-.086,31.1,31.1,0,0,0-3.337-.09A31.1,31.1,0,0,0,92,301.264Z",
    transform: "translate(-64.427 -192.44)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204136",
    "data-name": "Rectangle 204136",
    width: 6.621,
    height: 12.757,
    transform: "translate(34.222 129.388) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510550",
    "data-name": "Path 510550",
    d: "M99.556,333.177c.049,0,.09-2.853.09-6.379s-.041-6.379-.09-6.379-.086,2.873-.086,6.379S99.507,333.177,99.556,333.177Z",
    transform: "translate(-68.831 -203.793)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510551",
    "data-name": "Path 510551",
    d: "M92.07,331.08a30.57,30.57,0,0,0,3.308.09,30.63,30.63,0,0,0,3.312-.09,31.34,31.34,0,0,0-3.312-.086,31.3,31.3,0,0,0-3.308.086Z",
    transform: "translate(-64.468 -210.02)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510552",
    "data-name": "Path 510552",
    d: "M92,342.194a31.824,31.824,0,0,0,3.337.086,31.824,31.824,0,0,0,3.337-.086,31.079,31.079,0,0,0-3.337-.09A31.1,31.1,0,0,0,92,342.194Z",
    transform: "translate(-64.427 -216.57)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204137",
    "data-name": "Rectangle 204137",
    width: 6.621,
    height: 12.757,
    transform: "translate(34.222 146.185) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510553",
    "data-name": "Path 510553",
    d: "M99.556,374.107c.049,0,.09-2.873.09-6.379s-.041-6.379-.09-6.379-.086,2.873-.086,6.379S99.507,374.107,99.556,374.107Z",
    transform: "translate(-68.831 -227.923)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510554",
    "data-name": "Path 510554",
    d: "M92.07,372a31.3,31.3,0,0,0,3.308.086A31.34,31.34,0,0,0,98.691,372a30.63,30.63,0,0,0-3.312-.09,30.578,30.578,0,0,0-3.308.09Z",
    transform: "translate(-64.468 -234.144)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510555",
    "data-name": "Path 510555",
    d: "M92,383.12a31.111,31.111,0,0,0,3.337.09,31.1,31.1,0,0,0,3.337-.09,31.824,31.824,0,0,0-3.337-.086A31.816,31.816,0,0,0,92,383.12Z",
    transform: "translate(-64.427 -240.699)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204138",
    "data-name": "Rectangle 204138",
    width: 6.621,
    height: 12.757,
    transform: "translate(50.263 162.435) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510556",
    "data-name": "Path 510556",
    d: "M138.636,413.677c.049,0,.09-2.873.09-6.379s-.041-6.379-.09-6.379-.086,2.853-.086,6.379S138.587,413.677,138.636,413.677Z",
    transform: "translate(-91.87 -251.251)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510557",
    "data-name": "Path 510557",
    d: "M131.15,411.6a30.623,30.623,0,0,0,3.312.09,30.578,30.578,0,0,0,3.308-.09,32.66,32.66,0,0,0-3.308-.086,32.714,32.714,0,0,0-3.312.086Z",
    transform: "translate(-87.508 -257.491)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510558",
    "data-name": "Path 510558",
    d: "M131.07,422.714a31.824,31.824,0,0,0,3.337.086,31.824,31.824,0,0,0,3.337-.086,31.094,31.094,0,0,0-3.337-.09A31.1,31.1,0,0,0,131.07,422.714Z",
    transform: "translate(-87.46 -264.039)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204139",
    "data-name": "Rectangle 204139",
    width: 6.621,
    height: 12.757,
    transform: "translate(34.222 162.985) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510559",
    "data-name": "Path 510559",
    d: "M99.556,415.037c.049,0,.09-2.873.09-6.379s-.041-6.379-.09-6.379-.086,2.873-.086,6.379S99.507,415.037,99.556,415.037Z",
    transform: "translate(-68.831 -252.052)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510560",
    "data-name": "Path 510560",
    d: "M92.07,412.934a31.287,31.287,0,0,0,3.308.086,31.34,31.34,0,0,0,3.312-.086,30.63,30.63,0,0,0-3.312-.09,30.578,30.578,0,0,0-3.308.09Z",
    transform: "translate(-64.468 -258.274)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510561",
    "data-name": "Path 510561",
    d: "M92,424.05a31.1,31.1,0,0,0,3.337.09,31.1,31.1,0,0,0,3.337-.09,31.832,31.832,0,0,0-3.337-.086A31.832,31.832,0,0,0,92,424.05Z",
    transform: "translate(-64.427 -264.829)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204140",
    "data-name": "Rectangle 204140",
    width: 20.704,
    height: 87.56,
    transform: "translate(258.084 174.244) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204141",
    "data-name": "Rectangle 204141",
    width: 6.292,
    height: 12.129,
    transform: "translate(254.226 104.945) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510562",
    "data-name": "Path 510562",
    d: "M635.972,274.585c.045,0,.086-2.713.086-6.063s-.041-6.062-.086-6.062-.082,2.713-.082,6.063S635.935,274.585,635.972,274.585Z",
    transform: "translate(-385.071 -169.623)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510563",
    "data-name": "Path 510563",
    d: "M628.86,272.562a57.461,57.461,0,0,0,6.292,0A60.341,60.341,0,0,0,628.86,272.562Z",
    transform: "translate(-380.927 -175.53)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510564",
    "data-name": "Path 510564",
    d: "M628.78,283.132a58.379,58.379,0,0,0,6.342,0A61.271,61.271,0,0,0,628.78,283.132Z",
    transform: "translate(-380.879 -181.762)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204142",
    "data-name": "Rectangle 204142",
    width: 6.292,
    height: 12.129,
    transform: "translate(254.226 120.789) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510565",
    "data-name": "Path 510565",
    d: "M635.972,313.139c.045,0,.086-2.717.086-6.063s-.041-6.067-.086-6.067-.082,2.717-.082,6.067S635.935,313.139,635.972,313.139Z",
    transform: "translate(-385.071 -192.35)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510566",
    "data-name": "Path 510566",
    d: "M628.86,311.156a60.341,60.341,0,0,0,6.292,0,57.476,57.476,0,0,0-6.292,0Z",
    transform: "translate(-380.927 -198.281)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510567",
    "data-name": "Path 510567",
    d: "M628.78,321.722a58.348,58.348,0,0,0,6.342,0A61.288,61.288,0,0,0,628.78,321.722Z",
    transform: "translate(-380.879 -204.512)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204143",
    "data-name": "Rectangle 204143",
    width: 6.292,
    height: 12.129,
    transform: "translate(254.226 136.629) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510568",
    "data-name": "Path 510568",
    d: "M635.972,351.729c.045,0,.086-2.713.086-6.062s-.041-6.067-.086-6.067-.082,2.717-.082,6.067S635.935,351.729,635.972,351.729Z",
    transform: "translate(-385.071 -215.1)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510569",
    "data-name": "Path 510569",
    d: "M628.86,349.746a60.341,60.341,0,0,0,6.292,0A57.461,57.461,0,0,0,628.86,349.746Z",
    transform: "translate(-380.927 -221.031)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510570",
    "data-name": "Path 510570",
    d: "M628.78,360.316a61.273,61.273,0,0,0,6.342,0A58.364,58.364,0,0,0,628.78,360.316Z",
    transform: "translate(-380.879 -227.262)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204144",
    "data-name": "Rectangle 204144",
    width: 6.292,
    height: 12.129,
    transform: "translate(254.226 152.469) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510571",
    "data-name": "Path 510571",
    d: "M635.972,390.325c.045,0,.086-2.713.086-6.063s-.041-6.062-.086-6.062-.082,2.713-.082,6.063S635.935,390.325,635.972,390.325Z",
    transform: "translate(-385.071 -237.856)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510572",
    "data-name": "Path 510572",
    d: "M628.86,388.342a57.445,57.445,0,0,0,6.292,0A60.358,60.358,0,0,0,628.86,388.342Z",
    transform: "translate(-380.927 -243.787)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510573",
    "data-name": "Path 510573",
    d: "M628.78,398.876a61.264,61.264,0,0,0,6.342,0A58.388,58.388,0,0,0,628.78,398.876Z",
    transform: "translate(-380.879 -249.995)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204145",
    "data-name": "Rectangle 204145",
    width: 15.084,
    height: 87.56,
    transform: "translate(243.661 174.244) rotate(180)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204146",
    "data-name": "Rectangle 204146",
    width: 6.292,
    height: 12.129,
    transform: "translate(238.977 104.945) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510574",
    "data-name": "Path 510574",
    d: "M598.816,274.585c.045,0,.082-2.713.082-6.063s-.037-6.062-.082-6.062-.086,2.713-.086,6.063S598.767,274.585,598.816,274.585Z",
    transform: "translate(-363.164 -169.623)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510575",
    "data-name": "Path 510575",
    d: "M591.7,272.562a57.462,57.462,0,0,0,6.292,0A60.342,60.342,0,0,0,591.7,272.562Z",
    transform: "translate(-359.019 -175.53)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510576",
    "data-name": "Path 510576",
    d: "M591.62,283.132a58.44,58.44,0,0,0,6.346,0A61.335,61.335,0,0,0,591.62,283.132Z",
    transform: "translate(-358.972 -181.762)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204147",
    "data-name": "Rectangle 204147",
    width: 6.292,
    height: 12.129,
    transform: "translate(238.977 120.917) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510577",
    "data-name": "Path 510577",
    d: "M598.816,313.455c.045,0,.082-2.713.082-6.063s-.037-6.062-.082-6.062-.086,2.713-.086,6.063S598.767,313.455,598.816,313.455Z",
    transform: "translate(-363.164 -192.538)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510578",
    "data-name": "Path 510578",
    d: "M591.7,311.472a57.462,57.462,0,0,0,6.292,0,60.35,60.35,0,0,0-6.292,0Z",
    transform: "translate(-359.019 -198.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510579",
    "data-name": "Path 510579",
    d: "M591.62,322.036a61.369,61.369,0,0,0,6.346,0,58.432,58.432,0,0,0-6.346,0Z",
    transform: "translate(-358.972 -204.695)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204148",
    "data-name": "Rectangle 204148",
    width: 6.292,
    height: 12.129,
    transform: "translate(238.977 136.888) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510580",
    "data-name": "Path 510580",
    d: "M598.816,352.365c.045,0,.082-2.713.082-6.063s-.037-6.062-.082-6.062-.086,2.713-.086,6.063S598.767,352.365,598.816,352.365Z",
    transform: "translate(-363.164 -215.477)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510581",
    "data-name": "Path 510581",
    d: "M591.7,350.382a57.462,57.462,0,0,0,6.292,0A60.342,60.342,0,0,0,591.7,350.382Z",
    transform: "translate(-359.019 -221.408)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510582",
    "data-name": "Path 510582",
    d: "M591.62,360.946a61.343,61.343,0,0,0,6.346,0,58.44,58.44,0,0,0-6.346,0Z",
    transform: "translate(-358.972 -227.634)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204149",
    "data-name": "Rectangle 204149",
    width: 6.292,
    height: 12.129,
    transform: "translate(238.977 152.859) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510583",
    "data-name": "Path 510583",
    d: "M598.816,391.275c.045,0,.082-2.713.082-6.062s-.037-6.063-.082-6.063-.086,2.713-.086,6.063S598.767,391.275,598.816,391.275Z",
    transform: "translate(-363.164 -238.416)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510584",
    "data-name": "Path 510584",
    d: "M591.7,389.292a57.462,57.462,0,0,0,6.292,0,60.35,60.35,0,0,0-6.292,0Z",
    transform: "translate(-359.019 -244.347)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510585",
    "data-name": "Path 510585",
    d: "M591.62,399.876a61.352,61.352,0,0,0,6.346,0A58.44,58.44,0,0,0,591.62,399.876Z",
    transform: "translate(-358.972 -250.584)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204150",
    "data-name": "Rectangle 204150",
    width: 6.292,
    height: 12.129,
    transform: "translate(254.226 168.313) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510586",
    "data-name": "Path 510586",
    d: "M635.972,428.919c.045,0,.086-2.717.086-6.067s-.041-6.063-.086-6.063-.082,2.713-.082,6.063S635.935,428.919,635.972,428.919Z",
    transform: "translate(-385.071 -260.607)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510587",
    "data-name": "Path 510587",
    d: "M628.86,426.932a57.461,57.461,0,0,0,6.292,0A60.374,60.374,0,0,0,628.86,426.932Z",
    transform: "translate(-380.927 -266.537)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510588",
    "data-name": "Path 510588",
    d: "M628.78,437.5a58.363,58.363,0,0,0,6.342,0A61.288,61.288,0,0,0,628.78,437.5Z",
    transform: "translate(-380.879 -272.769)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204151",
    "data-name": "Rectangle 204151",
    width: 6.292,
    height: 12.129,
    transform: "translate(238.977 168.83) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510589",
    "data-name": "Path 510589",
    d: "M598.816,430.185c.045,0,.082-2.713.082-6.063s-.037-6.063-.082-6.063-.086,2.713-.086,6.063S598.767,430.185,598.816,430.185Z",
    transform: "translate(-363.164 -261.355)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510590",
    "data-name": "Path 510590",
    d: "M591.7,428.2a57.477,57.477,0,0,0,6.292,0A60.342,60.342,0,0,0,591.7,428.2Z",
    transform: "translate(-359.019 -267.286)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510591",
    "data-name": "Path 510591",
    d: "M591.62,438.766a61.335,61.335,0,0,0,6.346,0A58.44,58.44,0,0,0,591.62,438.766Z",
    transform: "translate(-358.972 -273.512)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204152",
    "data-name": "Rectangle 204152",
    width: 12.396,
    height: 52.412,
    transform: "translate(272.697 174.203) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204153",
    "data-name": "Rectangle 204153",
    width: 3.768,
    height: 7.261,
    transform: "translate(270.386 132.721) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510592",
    "data-name": "Path 510592",
    d: "M678.643,349.2c.025,0,.049-1.642.049-3.628s-.025-3.633-.049-3.633-.053,1.642-.053,3.633S678.615,349.2,678.643,349.2Z",
    transform: "translate(-410.244 -216.48)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510593",
    "data-name": "Path 510593",
    d: "M674.39,348.013c0,.025.841.049,1.88.049s1.884-.025,1.884-.049a33.219,33.219,0,0,0-3.764,0Z",
    transform: "translate(-407.768 -220.029)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510594",
    "data-name": "Path 510594",
    d: "M674.34,354.339a36.627,36.627,0,0,0,3.8,0A36.593,36.593,0,0,0,674.34,354.339Z",
    transform: "translate(-407.739 -223.76)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204154",
    "data-name": "Rectangle 204154",
    width: 3.768,
    height: 7.261,
    transform: "translate(270.386 142.203) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510595",
    "data-name": "Path 510595",
    d: "M678.643,372.3c.025,0,.049-1.642.049-3.628s-.025-3.633-.049-3.633-.053,1.642-.053,3.633S678.615,372.3,678.643,372.3Z",
    transform: "translate(-410.244 -230.098)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510596",
    "data-name": "Path 510596",
    d: "M674.39,371.113a35.978,35.978,0,0,0,3.764,0A33.212,33.212,0,0,0,674.39,371.113Z",
    transform: "translate(-407.768 -233.647)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510597",
    "data-name": "Path 510597",
    d: "M674.34,377.439a33.788,33.788,0,0,0,3.8,0A36.593,36.593,0,0,0,674.34,377.439Z",
    transform: "translate(-407.739 -237.379)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204155",
    "data-name": "Rectangle 204155",
    width: 3.768,
    height: 7.261,
    transform: "translate(270.386 151.685) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510598",
    "data-name": "Path 510598",
    d: "M678.643,395.4c.025,0,.049-1.642.049-3.628s-.025-3.633-.049-3.633-.053,1.642-.053,3.633S678.615,395.4,678.643,395.4Z",
    transform: "translate(-410.244 -243.716)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510599",
    "data-name": "Path 510599",
    d: "M674.39,394.219a35.994,35.994,0,0,0,3.764,0A35.978,35.978,0,0,0,674.39,394.219Z",
    transform: "translate(-407.768 -247.271)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510600",
    "data-name": "Path 510600",
    d: "M674.34,400.539a33.788,33.788,0,0,0,3.8,0c0-.025-.85-.049-1.9-.049S674.34,400.515,674.34,400.539Z",
    transform: "translate(-407.739 -250.997)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204156",
    "data-name": "Rectangle 204156",
    width: 3.768,
    height: 7.261,
    transform: "translate(270.386 161.166) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510601",
    "data-name": "Path 510601",
    d: "M678.643,418.507c.025,0,.049-1.642.049-3.629s-.025-3.628-.049-3.628-.053,1.621-.053,3.628S678.615,418.507,678.643,418.507Z",
    transform: "translate(-410.244 -257.34)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510602",
    "data-name": "Path 510602",
    d: "M674.39,417.319a35.978,35.978,0,0,0,3.764,0A35.978,35.978,0,0,0,674.39,417.319Z",
    transform: "translate(-407.768 -260.889)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510603",
    "data-name": "Path 510603",
    d: "M674.34,423.639a33.8,33.8,0,0,0,3.8,0c0-.025-.85-.049-1.9-.049S674.34,423.615,674.34,423.639Z",
    transform: "translate(-407.739 -264.615)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204157",
    "data-name": "Rectangle 204157",
    width: 9.03,
    height: 52.412,
    transform: "translate(264.065 174.203) rotate(180)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204158",
    "data-name": "Rectangle 204158",
    width: 3.768,
    height: 7.261,
    transform: "translate(261.257 132.721) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510604",
    "data-name": "Path 510604",
    d: "M656.4,349.2c.025,0,.049-1.642.049-3.628s-.025-3.633-.049-3.633-.053,1.642-.053,3.633S656.375,349.2,656.4,349.2Z",
    transform: "translate(-397.133 -216.48)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510605",
    "data-name": "Path 510605",
    d: "M652.15,348.013c0,.025.841.049,1.88.049s1.884-.025,1.884-.049A33.22,33.22,0,0,0,652.15,348.013Z",
    transform: "translate(-394.657 -220.029)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510606",
    "data-name": "Path 510606",
    d: "M652.1,354.339a36.625,36.625,0,0,0,3.8,0A36.591,36.591,0,0,0,652.1,354.339Z",
    transform: "translate(-394.627 -223.76)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204159",
    "data-name": "Rectangle 204159",
    width: 3.768,
    height: 7.261,
    transform: "translate(261.257 142.281) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510607",
    "data-name": "Path 510607",
    d: "M656.4,372.491c.025,0,.049-1.642.049-3.628s-.025-3.633-.049-3.633-.053,1.642-.053,3.633S656.375,372.491,656.4,372.491Z",
    transform: "translate(-397.133 -230.21)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510608",
    "data-name": "Path 510608",
    d: "M652.15,371.3c0,.025.841.049,1.88.049s1.884-.025,1.884-.049A33.234,33.234,0,0,0,652.15,371.3Z",
    transform: "translate(-394.657 -233.759)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510609",
    "data-name": "Path 510609",
    d: "M652.1,377.629a36.608,36.608,0,0,0,3.8,0,36.6,36.6,0,0,0-3.8,0Z",
    transform: "translate(-394.627 -237.491)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204160",
    "data-name": "Rectangle 204160",
    width: 3.768,
    height: 7.261,
    transform: "translate(261.257 151.841) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510610",
    "data-name": "Path 510610",
    d: "M656.4,395.781c.025,0,.049-1.642.049-3.628s-.025-3.633-.049-3.633-.053,1.642-.053,3.633S656.375,395.781,656.4,395.781Z",
    transform: "translate(-397.133 -243.94)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510611",
    "data-name": "Path 510611",
    d: "M652.15,394.6a35.978,35.978,0,0,0,3.764,0,35.986,35.986,0,0,0-3.764,0Z",
    transform: "translate(-394.657 -247.495)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510612",
    "data-name": "Path 510612",
    d: "M652.1,400.929a33.8,33.8,0,0,0,3.8,0A36.625,36.625,0,0,0,652.1,400.929Z",
    transform: "translate(-394.627 -251.227)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204161",
    "data-name": "Rectangle 204161",
    width: 3.768,
    height: 7.261,
    transform: "translate(261.257 161.4) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510613",
    "data-name": "Path 510613",
    d: "M656.4,419.071c.025,0,.049-1.642.049-3.628s-.025-3.633-.049-3.633-.053,1.642-.053,3.633S656.375,419.071,656.4,419.071Z",
    transform: "translate(-397.133 -257.671)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510614",
    "data-name": "Path 510614",
    d: "M652.15,417.929a35.978,35.978,0,0,0,3.764,0A35.978,35.978,0,0,0,652.15,417.929Z",
    transform: "translate(-394.657 -261.249)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510615",
    "data-name": "Path 510615",
    d: "M652.1,424.209a33.793,33.793,0,0,0,3.8,0c0-.025-.85-.049-1.9-.049S652.1,424.185,652.1,424.209Z",
    transform: "translate(-394.627 -264.951)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204162",
    "data-name": "Rectangle 204162",
    width: 3.768,
    height: 7.261,
    transform: "translate(270.386 170.648) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510616",
    "data-name": "Path 510616",
    d: "M678.643,441.577c.025,0,.049-1.642.049-3.628s-.025-3.629-.049-3.629-.053,1.642-.053,3.629S678.615,441.577,678.643,441.577Z",
    transform: "translate(-410.244 -270.941)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510617",
    "data-name": "Path 510617",
    d: "M674.39,440.419a35.978,35.978,0,0,0,3.764,0A35.978,35.978,0,0,0,674.39,440.419Z",
    transform: "translate(-407.768 -274.508)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510618",
    "data-name": "Path 510618",
    d: "M674.34,446.743c0,.025.85.049,1.9.049s1.9-.025,1.9-.049A33.788,33.788,0,0,0,674.34,446.743Z",
    transform: "translate(-407.739 -278.234)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204163",
    "data-name": "Rectangle 204163",
    width: 3.768,
    height: 7.261,
    transform: "translate(261.257 170.964) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510619",
    "data-name": "Path 510619",
    d: "M656.4,442.361c.025,0,.049-1.642.049-3.628s-.025-3.633-.049-3.633-.053,1.642-.053,3.633S656.375,442.361,656.4,442.361Z",
    transform: "translate(-397.133 -271.401)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510620",
    "data-name": "Path 510620",
    d: "M652.15,441.179a35.978,35.978,0,0,0,3.764,0,35.986,35.986,0,0,0-3.764,0Z",
    transform: "translate(-394.657 -274.956)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510621",
    "data-name": "Path 510621",
    d: "M652.1,447.5a33.8,33.8,0,0,0,3.8,0c0-.025-.85-.049-1.9-.049S652.1,447.475,652.1,447.5Z",
    transform: "translate(-394.627 -278.682)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510622",
    "data-name": "Path 510622",
    d: "M395.569,87.991c.193-1.416-1.806-2.582-3.308-2.7a8.629,8.629,0,0,1-2.138-.185c-1.469-.513-2.052-2.414-3.493-3.017a4.111,4.111,0,0,0-3.345.472,8.651,8.651,0,0,1-3.23,1.256c-1.01.066-2.106-.308-2.992.185-.657.369-1,1.129-1.609,1.576a3.883,3.883,0,0,1-2.106.571,5.927,5.927,0,0,0-2.171.353,1.711,1.711,0,0,0-1.088,1.744Z",
    transform: "translate(-228.357 -63.172)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510623",
    "data-name": "Path 510623",
    d: "M535.089,42.386c.2-1.416-1.8-2.582-3.3-2.7a8.453,8.453,0,0,1-2.143-.185c-1.469-.509-2.052-2.409-3.489-3.017a4.1,4.1,0,0,0-3.349.476,8.582,8.582,0,0,1-3.23,1.256c-1.01.066-2.106-.312-2.988.185-.661.365-1.006,1.125-1.613,1.572a3.8,3.8,0,0,1-2.106.571,5.931,5.931,0,0,0-2.171.357,1.709,1.709,0,0,0-1.088,1.74Z",
    transform: "translate(-310.609 -36.283)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510624",
    "data-name": "Path 510624",
    d: "M50.345,183.761c.2-1.416-1.8-2.582-3.284-2.7a8.4,8.4,0,0,1-2.139-.185c-1.474-.513-2.052-2.414-3.493-3.017a4.12,4.12,0,0,0-3.349.472,8.687,8.687,0,0,1-3.226,1.256c-1.014.066-2.11-.308-2.992.185-.661.369-1.006,1.129-1.613,1.576a3.875,3.875,0,0,1-2.143.558,5.956,5.956,0,0,0-2.171.353A1.716,1.716,0,0,0,24.848,184Z",
    transform: "translate(-24.825 -119.632)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510625",
    "data-name": "Path 510625",
    d: "M243.886,48.124c.238-1.72-2.188-3.132-4.01-3.284a10.3,10.3,0,0,1-2.594-.226c-1.781-.62-2.5-2.922-4.236-3.657a4.966,4.966,0,0,0-4.059.575,10.568,10.568,0,0,1-3.916,1.523c-1.231.078-2.557-.378-3.628.222-.8.447-1.231,1.367-1.954,1.913a4.519,4.519,0,0,1-2.553.69,7.122,7.122,0,0,0-2.635.431,2.083,2.083,0,0,0-1.318,2.114Z",
    transform: "translate(-135.736 -38.898)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510626",
    "data-name": "Path 510626",
    d: "M643.155,201.364c.238-1.716-2.188-3.132-4.01-3.284a10.285,10.285,0,0,1-2.594-.226c-1.781-.62-2.5-2.927-4.236-3.657a4.966,4.966,0,0,0-4.059.575,10.568,10.568,0,0,1-3.916,1.523c-1.231.078-2.557-.378-3.628.222-.8.447-1.231,1.367-1.954,1.909a4.547,4.547,0,0,1-2.557.694,7.1,7.1,0,0,0-2.631.431,2.077,2.077,0,0,0-1.318,2.114Z",
    transform: "translate(-371.119 -129.239)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-62",
    transform: "translate(29.075 210.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510627",
    "data-name": "Path 510627",
    d: "M302.764,460.621h-2.717l-7.8.021-28.675.033-94.591.078-94.616-.033L45.7,460.687l-7.8-.021h0l7.8-.02,28.671-.033,94.616-.033,94.6.033,28.675.033,7.8.02h2.028Z",
    transform: "translate(-35.18 -460.58)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Building--inject-62",
    transform: "translate(73.639 60.577)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204164",
    "data-name": "Rectangle 204164",
    width: 22.855,
    height: 13.414,
    transform: "translate(42.688 2.598)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204165",
    "data-name": "Rectangle 204165",
    width: 22.855,
    height: 13.414,
    transform: "translate(31.864 2.151)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204166",
    "data-name": "Rectangle 204166",
    width: 99.18,
    height: 5.406,
    transform: "translate(0.025 14.974)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204167",
    "data-name": "Rectangle 204167",
    width: 37.483,
    height: 2.91,
    transform: "translate(29.512 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510628",
    "data-name": "Path 510628",
    d: "M226.171,274.649l-69.742-.09L156.31,145.12h69.861Z",
    transform: "translate(-151.155 -124.741)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204168",
    "data-name": "Rectangle 204168",
    width: 8.029,
    height: 14.436,
    transform: "translate(12.458 28.576)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204169",
    "data-name": "Rectangle 204169",
    width: 8.029,
    height: 14.436,
    transform: "translate(12.458 49.457)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204170",
    "data-name": "Rectangle 204170",
    width: 8.029,
    height: 14.436,
    transform: "translate(12.458 70.337)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204171",
    "data-name": "Rectangle 204171",
    width: 8.029,
    height: 14.436,
    transform: "translate(12.458 91.217)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204172",
    "data-name": "Rectangle 204172",
    width: 8.029,
    height: 14.436,
    transform: "translate(12.458 110.628)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204173",
    "data-name": "Rectangle 204173",
    width: 8.029,
    height: 14.436,
    transform: "translate(58.643 28.576)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204174",
    "data-name": "Rectangle 204174",
    width: 7.298,
    height: 9.424,
    transform: "translate(36.584 6.239)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204175",
    "data-name": "Rectangle 204175",
    width: 8.029,
    height: 14.436,
    transform: "translate(58.643 49.457)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204176",
    "data-name": "Rectangle 204176",
    width: 8.029,
    height: 14.436,
    transform: "translate(58.643 70.337)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204177",
    "data-name": "Rectangle 204177",
    width: 8.029,
    height: 14.436,
    transform: "translate(58.643 91.217)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204178",
    "data-name": "Rectangle 204178",
    width: 8.029,
    height: 14.436,
    transform: "translate(58.643 110.628)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204179",
    "data-name": "Rectangle 204179",
    width: 23.671,
    height: 129.525,
    transform: "translate(27.419 20.379)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633190",
    "data-name": "Group 633190",
    transform: "translate(27.419 60.49)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510629",
    "data-name": "Path 510629",
    d: "M234.221,242.84,210.55,262.563v7.208l23.671-20.047Z",
    transform: "translate(-210.55 -242.84)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_633191",
    "data-name": "Group 633191",
    transform: "translate(27.419 22.801)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510630",
    "data-name": "Path 510630",
    d: "M234.221,151.02,210.55,170.743v7.208L234.221,157.9Z",
    transform: "translate(-210.55 -151.02)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_633192",
    "data-name": "Group 633192",
    transform: "translate(27.419 76.395)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510631",
    "data-name": "Path 510631",
    d: "M234.221,281.59,210.55,301.313v14.51l23.671-19.969Z",
    transform: "translate(-210.55 -281.59)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204180",
    "data-name": "Rectangle 204180",
    width: 19.534,
    height: 130.617,
    transform: "translate(75.02 19.181)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510632",
    "data-name": "Path 510632",
    d: "M374.441,291.419c-.057,0-.168-26.339-.246-58.827s-.1-58.832-.037-58.832.168,26.335.25,58.832S374.5,291.419,374.441,291.419Z",
    transform: "translate(-279.563 -141.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204181",
    "data-name": "Rectangle 204181",
    width: 8.029,
    height: 14.436,
    transform: "translate(81.583 28.576)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204182",
    "data-name": "Rectangle 204182",
    width: 8.029,
    height: 14.436,
    transform: "translate(81.583 49.457)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204183",
    "data-name": "Rectangle 204183",
    width: 8.029,
    height: 14.436,
    transform: "translate(81.583 70.337)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204184",
    "data-name": "Rectangle 204184",
    width: 8.029,
    height: 14.436,
    transform: "translate(81.583 91.217)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204185",
    "data-name": "Rectangle 204185",
    width: 8.029,
    height: 14.436,
    transform: "translate(81.583 110.628)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204186",
    "data-name": "Rectangle 204186",
    width: 8.029,
    height: 14.436,
    transform: "translate(81.583 130.962)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204187",
    "data-name": "Rectangle 204187",
    width: 27.193,
    height: 2.717,
    transform: "translate(25.473 125.372)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204188",
    "data-name": "Rectangle 204188",
    width: 23.671,
    height: 1.58,
    transform: "translate(27.419 43.887)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204189",
    "data-name": "Rectangle 204189",
    width: 23.671,
    height: 1.58,
    transform: "translate(27.419 66.725)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204190",
    "data-name": "Rectangle 204190",
    width: 23.671,
    height: 1.58,
    transform: "translate(27.234 108.415)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204191",
    "data-name": "Rectangle 204191",
    width: 23.671,
    height: 1.58,
    transform: "translate(28.318 88.508)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510633",
    "data-name": "Path 510633",
    d: "M233.911,325.319c.037.045-3.5,3.132-7.889,6.9s-7.992,6.777-8.033,6.732,3.5-3.132,7.893-6.9S233.87,325.274,233.911,325.319Z",
    transform: "translate(-187.517 -230.975)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510634",
    "data-name": "Path 510634",
    d: "M234.407,359.479c.041.045-3.493,3.132-7.889,6.9s-7.992,6.777-8.029,6.732,3.493-3.132,7.889-6.892S234.37,359.434,234.407,359.479Z",
    transform: "translate(-187.812 -251.113)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510635",
    "data-name": "Path 510635",
    d: "M239.738,274.9c.037.045-2.553,2.311-5.788,5.061s-5.89,4.926-5.931,4.9,2.553-2.311,5.792-5.061S239.7,274.854,239.738,274.9Z",
    transform: "translate(-193.43 -201.25)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510636",
    "data-name": "Path 510636",
    d: "M234.144,281.17a24.214,24.214,0,0,1-2.245,2.2,23.73,23.73,0,0,1-2.389,2.052,22.758,22.758,0,0,1,2.245-2.2A22.256,22.256,0,0,1,234.144,281.17Z",
    transform: "translate(-194.309 -204.947)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510637",
    "data-name": "Path 510637",
    d: "M220.76,222.864c-.033-.049,3.526-2.767,7.951-6.067s8.041-5.943,8.074-5.9-3.522,2.767-7.947,6.071S220.8,222.909,220.76,222.864Z",
    transform: "translate(-189.15 -163.52)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510638",
    "data-name": "Path 510638",
    d: "M232.71,229.411a4.748,4.748,0,0,1,.821-.6l2.019-1.363,2.007-1.387a4.817,4.817,0,0,1,.854-.546,4.819,4.819,0,0,1-.763.665c-.493.39-1.186.9-1.974,1.445s-1.523,1-2.052,1.313A4.412,4.412,0,0,1,232.71,229.411Z",
    transform: "translate(-196.195 -172.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510639",
    "data-name": "Path 510639",
    d: "M234.513,156.79a1.309,1.309,0,0,1-.16.156c-.111.094-.283.246-.48.41l-1.785,1.486-5.907,4.884-5.882,4.926-1.785,1.49-.488.41c-.115.09-.177.135-.185.127a1.182,1.182,0,0,1,.156-.16l.464-.41c.435-.382,1.026-.9,1.74-1.539,1.482-1.289,3.542-3.05,5.845-4.967s4.408-3.62,5.948-4.839l1.831-1.433.5-.378a.929.929,0,0,1,.185-.164Z",
    transform: "translate(-187.429 -131.62)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510640",
    "data-name": "Path 510640",
    d: "M236.344,164a11.222,11.222,0,0,1-1.666,1.445,11.666,11.666,0,0,1-1.8,1.272,11.083,11.083,0,0,1,1.666-1.441,11.759,11.759,0,0,1,1.8-1.277Z",
    transform: "translate(-196.296 -135.871)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510641",
    "data-name": "Path 510641",
    d: "M182.962,230.52a13.424,13.424,0,0,1-1.642,1.7,13.136,13.136,0,0,1-1.81,1.535,14.024,14.024,0,0,1,1.662-1.7,12.957,12.957,0,0,1,1.79-1.535Z",
    transform: "translate(-164.832 -175.087)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510642",
    "data-name": "Path 510642",
    d: "M296.6,280.84a16.7,16.7,0,0,1-1.687,1.983,15.45,15.45,0,0,1-1.843,1.843,15.329,15.329,0,0,1,1.687-1.987A15.6,15.6,0,0,1,296.6,280.84Z",
    transform: "translate(-231.78 -204.753)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510643",
    "data-name": "Path 510643",
    d: "M184.008,329.08a18.2,18.2,0,0,1-1.851,2.052,17.937,17.937,0,0,1-2.007,1.892A18.2,18.2,0,0,1,182,330.972,17.531,17.531,0,0,1,184.008,329.08Z",
    transform: "translate(-165.209 -233.192)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510644",
    "data-name": "Path 510644",
    d: "M293.372,373.77a13.786,13.786,0,0,1-1.6,1.818,13.638,13.638,0,0,1-1.757,1.666,14.164,14.164,0,0,1,1.6-1.818A13.956,13.956,0,0,1,293.372,373.77Z",
    transform: "translate(-229.976 -259.538)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510645",
    "data-name": "Path 510645",
    d: "M294.57,379.52a6.358,6.358,0,0,1-1.059,1.268,6.439,6.439,0,0,1-1.231,1.121,6.359,6.359,0,0,1,1.059-1.268A6.618,6.618,0,0,1,294.57,379.52Z",
    transform: "translate(-231.314 -262.928)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204192",
    "data-name": "Rectangle 204192",
    width: 8.029,
    height: 14.436,
    transform: "translate(58.643 131.565)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204193",
    "data-name": "Rectangle 204193",
    width: 8.029,
    height: 14.436,
    transform: "translate(12.4 131.327)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633193",
    "data-name": "Group 633193",
    transform: "translate(27.439 127.92)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510646",
    "data-name": "Path 510646",
    d: "M212.894,429.026l21.36-17.49,0-4.417-3.28.09L210.6,425.143l.045,3.875",
    transform: "translate(-210.6 -407.12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_633194",
    "data-name": "Group 633194",
    transform: "translate(34.573 135.264)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510647",
    "data-name": "Path 510647",
    d: "M227.98,439.581l1.97.029,14.559-12.679-.016-.915,0-1.006Z",
    transform: "translate(-227.98 -425.01)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510648",
    "data-name": "Path 510648",
    d: "M238.777,431.563c-.057,0-.107-4.515-.107-10.1s.049-10.1.107-10.1.107,4.515.107,10.1S238.838,431.563,238.777,431.563Z",
    transform: "translate(-199.709 -281.699)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204194",
    "data-name": "Rectangle 204194",
    width: 1.42,
    height: 4.901,
    transform: "translate(36.478 138.543)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204195",
    "data-name": "Rectangle 204195",
    width: 1.42,
    height: 4.901,
    transform: "translate(40.086 138.543)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510649",
    "data-name": "Path 510649",
    d: "M243.082,144.967c0,.057-22.231.107-49.666.107s-49.666-.049-49.666-.107,22.227-.107,49.666-.107S243.082,144.917,243.082,144.967Z",
    transform: "translate(-143.75 -124.587)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510650",
    "data-name": "Path 510650",
    d: "M243.082,132.057c0,.057-22.231.107-49.666.107s-49.666-.049-49.666-.107,22.227-.107,49.666-.107S243.082,132,243.082,132.057Z",
    transform: "translate(-143.75 -116.976)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510651",
    "data-name": "Path 510651",
    d: "M253.623,102.407c0,.057-8.427.107-18.82.107s-18.8-.049-18.8-.107,8.423-.107,18.82-.107S253.623,102.345,253.623,102.407Z",
    transform: "translate(-186.344 -99.497)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510652",
    "data-name": "Path 510652",
    d: "M156.17,275.5c-.057,0-.164-28.831-.238-64.389s-.082-64.393-.021-64.393.164,28.823.234,64.393S156.227,275.5,156.17,275.5Z",
    transform: "translate(-150.895 -125.684)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-62",
    transform: "translate(43.536 46.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510653",
    "data-name": "Path 510653",
    d: "M113.182,72.817,96.944,67.37,80.862,72.743C78.81,73.646,77,74.2,77,75.977v8.891a31.991,31.991,0,0,0,5.295,17.7,32.332,32.332,0,0,0,14.777,12.2c6.567-1.995,11.493-7.31,14.477-11.858a31.942,31.942,0,0,0,5.3-17.7v-8C116.876,74.672,115.431,73.428,113.182,72.817Z",
    transform: "translate(-74.295 -64.345)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510654",
    "data-name": "Path 510654",
    d: "M100.717,114.964l-.066-.029A28.133,28.133,0,0,1,83.19,88.944V81.269c0-1.5,1.326-2.052,2.873-2.721l.575-.25,13.956-4.667,14.067,4.72c2.245.612,3.337,1.921,3.337,4v6.9a27.85,27.85,0,0,1-4.605,15.384c-2,3.029-6.3,8.4-12.605,10.315Zm-.123-40.9L86.806,78.675l-.575.25c-1.478.6-2.631,1.112-2.631,2.344v7.676a27.719,27.719,0,0,0,17.161,25.584c6.157-1.9,10.348-7.154,12.314-10.126a27.448,27.448,0,0,0,4.515-15.158v-6.9c0-1.892-.969-3.037-3.037-3.6h0Z",
    transform: "translate(-77.945 -68.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510655",
    "data-name": "Path 510655",
    d: "M111.42,66.231a6.938,6.938,0,0,1,1.1.337,5.816,5.816,0,0,1,1.231.649,4.2,4.2,0,0,1,1.293,1.4,5.02,5.02,0,0,1,.607,2.315V73.8c0,2.052.021,4.417,0,7.044a35.964,35.964,0,0,1-4.95,17.818,40.1,40.1,0,0,1-6.978,8.8,27.192,27.192,0,0,1-10.454,6.309H93.2a42.08,42.08,0,0,1-4.22-2.052,38.175,38.175,0,0,1-4.035-2.656,36.158,36.158,0,0,1-7.052-7.044,36.765,36.765,0,0,1-5.188-9.4,36.367,36.367,0,0,1-2.192-10.044c-.127-1.675-.09-3.329-.1-4.95s0-3.222,0-4.794V70.483a7.987,7.987,0,0,1,.049-1.166,2.307,2.307,0,0,1,.488-1.071,5.418,5.418,0,0,1,1.859-1.3c.677-.316,1.359-.591,2.024-.882h0L93.035,60h.025l13.5,4.56,3.6,1.231.928.324c.209.07.312.115.312.115s-.107-.029-.316-.1l-.936-.3-3.616-1.19L93.015,60.123h.045L74.9,66.235h0c-.669.3-1.346.571-2.015.887A5.147,5.147,0,0,0,71.1,68.353a2.052,2.052,0,0,0-.443,1,6.854,6.854,0,0,0-.041,1.133v7.13c0,1.642-.029,3.284.1,4.926a35.94,35.94,0,0,0,2.18,10,36.531,36.531,0,0,0,5.168,9.342,35.944,35.944,0,0,0,7.007,7,38.38,38.38,0,0,0,4.01,2.643,43.437,43.437,0,0,0,4.195,2.052h-.041a26.818,26.818,0,0,0,10.381-6.255,40.02,40.02,0,0,0,6.978-8.751,36.223,36.223,0,0,0,3.821-9.215,36.76,36.76,0,0,0,1.149-8.517c0-2.619,0-4.979.025-7.039V70.926a4.86,4.86,0,0,0-.6-2.266,4.22,4.22,0,0,0-1.26-1.387,5.965,5.965,0,0,0-1.211-.661,7.839,7.839,0,0,0-.813-.291Z",
    transform: "translate(-70.411 -60)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510656",
    "data-name": "Path 510656",
    d: "M111.12,119.239l-9.17-7.672,2.676-3.2,6.149,5.143,9.416-10.023,3.042,2.853Z",
    transform: "translate(-89.004 -85.639)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-62",
    transform: "translate(251.903 51.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510657",
    "data-name": "Path 510657",
    d: "M578.05,103.164l2.873-4.926a18.11,18.11,0,1,1,3.152,5.673h0Z",
    transform: "translate(-578.05 -74.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510658",
    "data-name": "Path 510658",
    d: "M578.05,103.105l.41.041,1.162.14,4.486.546-.049.066h0l-.152-.324.23.275a18.126,18.126,0,0,0,7.167,5.25,17.885,17.885,0,0,0,2.664.841,19.92,19.92,0,0,0,2.959.41,17.937,17.937,0,0,0,12.724-4.187,18.142,18.142,0,0,0,4.7-6.083,17.831,17.831,0,0,0,1.707-7.975A17.65,17.65,0,0,0,613.9,83.85l-.575-.965c-.2-.312-.41-.607-.628-.911a17.834,17.834,0,0,0-1.359-1.7c-.23-.283-.513-.517-.768-.776a7.931,7.931,0,0,0-.792-.739l-.841-.669c-.14-.111-.275-.23-.41-.328l-.447-.291a18.265,18.265,0,0,0-7.741-2.943,18.049,18.049,0,0,0-18.126,9.338c-.123.23-.238.46-.357.685l-.176.337-.14.349L581,86.621a23.753,23.753,0,0,0-.69,2.717,18,18,0,0,0,.665,8.829h0c-.944,1.584-1.667,2.8-2.163,3.624l-.562.94-.2.324.176-.316.538-.936,2.13-3.694v.037a18.015,18.015,0,0,1-.727-8.837,24.555,24.555,0,0,1,.685-2.742l.542-1.391.14-.353.177-.341.357-.694a18.224,18.224,0,0,1,18.3-9.441,18.5,18.5,0,0,1,7.8,2.939l.456.3a3.365,3.365,0,0,1,.41.332l.85.677c.291.222.534.5.8.747a7.776,7.776,0,0,1,.776.784,17.172,17.172,0,0,1,1.383,1.732c.213.308.431.607.636.919l.55.981a18.118,18.118,0,0,1-17.12,26.754,20.16,20.16,0,0,1-2.984-.431,17.553,17.553,0,0,1-2.684-.858,18.06,18.06,0,0,1-7.183-5.336l.078-.049h0l.033.074h-.082l-4.515-.607-1.145-.16Z",
    transform: "translate(-578.05 -74.208)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204196",
    "data-name": "Rectangle 204196",
    width: 13.147,
    height: 13.147,
    transform: "translate(12.244 12.602)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510659",
    "data-name": "Path 510659",
    d: "M620.962,117.97a.555.555,0,0,1,0-.07v-.895c0-.636,0-1.539-.025-2.684,0-2.307-.029-5.578-.045-9.5l.09.094H607.848c-.025.025.2-.2.107-.1h0v13.139l-.09-.094,9.5.049h2.721l-2.664.025-9.56.045h-.094V104.831h0l.107-.111h13.229v.09c0,3.949-.037,7.241-.049,9.564,0,1.133,0,2.032-.025,2.66v.694A1.677,1.677,0,0,1,620.962,117.97Z",
    transform: "translate(-595.571 -92.196)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510660",
    "data-name": "Path 510660",
    d: "M617.646,113.144l-7.906-6.613,2.307-2.758,5.3,4.433,8.119-8.636,2.619,2.459Z",
    transform: "translate(-596.732 -89.16)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-62",
    transform: "translate(133.48 59.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510661",
    "data-name": "Path 510661",
    d: "M453.131,245.508l-9.724-6.5a6.489,6.489,0,0,0-7.54,4.811c-3.214-.673-6.625,1.58-7.729,4.671a9.584,9.584,0,0,0,1.995,9.194,14.892,14.892,0,0,0,8.5,4.618c4.634.919,10.052-.094,12.831-3.92C454.079,254.8,453.669,249.916,453.131,245.508Z",
    transform: "translate(-370.977 -179.039)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510662",
    "data-name": "Path 510662",
    d: "M544.958,194.253a8.887,8.887,0,0,0-5.073-7.832c1.112-3.883,2.336-7.959,1.478-11.9-1.941-8.915-9.974-10.138-14.013-10.081l-13.274,8.48c-3.555,4.027.907,26.134,2.508,31.261A16.033,16.033,0,0,0,527.8,214.744c3.694.924,7.955.337,10.787-2.233s3.731-7.3,1.433-10.352a8.891,8.891,0,0,0,4.934-7.906Z",
    transform: "translate(-421.122 -135.161)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510663",
    "data-name": "Path 510663",
    d: "M425.16,284.969l1.231,54.423,72.541.283s-5.385-76.4-6.933-77.142c-1.17-.554-15.5-5.258-15.5-5.258l-6.374-1.855-26.344,5.057-9.556,2.089Z",
    transform: "translate(-369.493 -188.8)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510664",
    "data-name": "Path 510664",
    d: "M409.384,285.487c0-.144,6.929-13.767,6.929-13.767-6.789.714-12.852,3.111-16.792,8.279-1.835,2.405-2.656,6.05-3.571,8.648-.616,1.761-4.679,25.449-4.679,25.449l16.094,6.584Z",
    transform: "translate(-349.514 -198.409)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510665",
    "data-name": "Path 510665",
    d: "M453.3,303.5,438.117,268.48c-5.533,1.231-11.752,2.635-15.717,5.188l2.1,25.744-.308,47.962,29.061.152,1.79-34.13Z",
    transform: "translate(-367.866 -196.499)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510666",
    "data-name": "Path 510666",
    d: "M536.332,305.312,533.2,262.054l-17.625-5.644-18,39.683v44.318l44.482-.148Z",
    transform: "translate(-412.188 -189.383)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510667",
    "data-name": "Path 510667",
    d: "M536.218,305.159s.041.209.111.616.172,1.018.308,1.806c.267,1.593.657,3.936,1.162,6.953,1,6.038,2.442,14.777,4.224,25.564v.09h-.057l-44.482.172h-.1V295.9h0c6.485-14.284,12.589-27.727,18.011-39.679l.037-.074.078.025,17.6,5.66h.053v.057c.944,13.25,1.712,24.065,2.245,31.569.263,3.752.468,6.674.6,8.661.07.989.119,1.749.152,2.262s.045.772.045.772-.029-.259-.07-.768-.1-1.272-.172-2.262c-.152-1.987-.369-4.905-.648-8.653-.554-7.507-1.346-18.319-2.323-31.569l.057.074-17.625-5.636.115-.049c-5.418,11.953-11.493,25.4-17.986,39.688v44.293l-.1-.1,44.482-.123-.078.09c-1.753-10.8-3.173-19.534-4.158-25.58-.484-3.017-.862-5.361-1.121-6.953-.123-.792-.218-1.4-.283-1.81S536.218,305.159,536.218,305.159Z",
    transform: "translate(-412.07 -189.23)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204197",
    "data-name": "Rectangle 204197",
    width: 62.456,
    height: 8.164,
    transform: "translate(56.894 114.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510668",
    "data-name": "Path 510668",
    d: "M585.11,271.67s4.059-.049,9.941,10.52c6.6,11.866,10.824,26.926,10.824,26.926l-16.258,8.874Z",
    transform: "translate(-463.79 -198.38)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510669",
    "data-name": "Path 510669",
    d: "M436.9,272.044l1.769,76.379,6.953.037-2.409-78.209A57.2,57.2,0,0,0,436.9,272.044Z",
    transform: "translate(-376.414 -197.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510670",
    "data-name": "Path 510670",
    d: "M553.89,261.38l-2.13,81.85h9.092l.427-79.387Z",
    transform: "translate(-444.129 -192.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633195",
    "data-name": "Group 633195",
    transform: "translate(91.11 85.74)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510671",
    "data-name": "Path 510671",
    d: "M511.51,307.184a10.491,10.491,0,0,0,5.02,7.877,25.229,25.229,0,0,1,4,2.29,10.969,10.969,0,0,1,2.463,3.665c4.926,9.872,9.851,19.768,13.664,30.128a31.258,31.258,0,0,0,3.017,6.74,9.448,9.448,0,0,0,5.8,4.281c2.426.468,5.233-.649,6.2-2.918L521,302Z",
    transform: "translate(-511.51 -302)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510672",
    "data-name": "Path 510672",
    d: "M453.076,302.9v3.173c0,2.052,0,5.094.025,8.956,0,7.737.025,18.816.041,32.2v.09h-.09l-29.11-.156h-.1v-.107c.053-8.62.111-17.908.168-27.5.045-7.113.09-14.054.135-20.72h0c-.722-9.03-1.408-17.576-2.052-25.449v-.082l.049-.033a34.111,34.111,0,0,1,8-3.358c2.668-.813,5.291-1.4,7.8-1.962h.07l.025.066,10.98,25.449c1.3,3.025,2.311,5.381,3,6.978l.776,1.822c.177.41.259.624.259.624s-.1-.209-.283-.62l-.747-1.814-3.042-6.978-11.041-25.42.094.049c-2.5.562-5.106,1.174-7.774,1.97a32.944,32.944,0,0,0-7.959,3.349l.045-.09c.636,7.877,1.33,16.419,2.052,25.449h0c-.041,6.67-.086,13.607-.131,20.72-.062,9.6-.123,18.881-.176,27.5l-.1-.1,29.106.185-.09.086c0-13.389.029-24.468.041-32.2,0-3.858,0-6.888.025-8.952v-2.352C453.063,303.137,453.076,302.9,453.076,302.9Z",
    transform: "translate(-367.683 -196.193)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510673",
    "data-name": "Path 510673",
    d: "M434.025,149.065a5.192,5.192,0,0,1,4.068-7.955l8.209,1.2-2.389,13.87a6.976,6.976,0,0,1-1.416,3.715,4.728,4.728,0,0,1-3.485,1.3,7.109,7.109,0,0,1-4.987-12.125Z",
    transform: "translate(-373.498 -121.41)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510674",
    "data-name": "Path 510674",
    d: "M466.41,186.127c6.855,0,14.268-7.236,14.4-14.091l.731-37.565c.571-11.082-5.4-20.638-16.488-20.9l-1.026.037a19.825,19.825,0,0,0-19.119,18.9c-.439,9.6-.062,18.274.181,23.4.5,10.631,10.43,12.314,10.43,12.314s-.854,9.359.608,12.117c3.284,6.182,5.878,5.652,10.282,5.746Z",
    transform: "translate(-381.017 -105.174)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510675",
    "data-name": "Path 510675",
    d: "M470.691,240.233A25.672,25.672,0,0,0,484.4,235.66s-3.173,8.053-13.816,7.462Z",
    transform: "translate(-396.27 -177.15)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510676",
    "data-name": "Path 510676",
    d: "M457.08,178.432a1.523,1.523,0,0,0,1.519,1.482,1.457,1.457,0,0,0,1.519-1.424,1.523,1.523,0,0,0-1.519-1.482,1.453,1.453,0,0,0-1.519,1.424Z",
    transform: "translate(-388.311 -142.572)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510677",
    "data-name": "Path 510677",
    d: "M451.58,167.28c.193.189,1.313-.7,2.947-.755s2.873.727,3.033.517c.082-.09-.123-.439-.657-.821a4.178,4.178,0,0,0-2.434-.657,4,4,0,0,0-2.34.846C451.642,166.829,451.482,167.194,451.58,167.28Z",
    transform: "translate(-385.053 -135.824)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510678",
    "data-name": "Path 510678",
    d: "M493.33,178.427a1.519,1.519,0,0,0,1.515,1.482,1.453,1.453,0,0,0,1.519-1.424A1.519,1.519,0,0,0,494.836,177a1.453,1.453,0,0,0-1.506,1.428Z",
    transform: "translate(-409.682 -142.567)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510679",
    "data-name": "Path 510679",
    d: "M490.633,167.53c.2.189,1.318-.7,2.951-.755s2.873.727,3.033.517c.082-.09-.119-.443-.657-.821a4.158,4.158,0,0,0-2.434-.657,4.01,4.01,0,0,0-2.344.846C490.7,167.082,490.538,167.448,490.633,167.53Z",
    transform: "translate(-408.077 -135.971)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510680",
    "data-name": "Path 510680",
    d: "M471.4,181.522a11.259,11.259,0,0,0-2.672-.386c-.41-.029-.821-.1-.895-.378a2.4,2.4,0,0,1,.234-1.231q.538-1.535,1.125-3.222c1.556-4.581,2.668-8.345,2.483-8.406s-1.6,3.6-3.152,8.189c-.374,1.129-.735,2.208-1.071,3.239a2.307,2.307,0,0,0-.16,1.642,1.043,1.043,0,0,0,.706.587,2.722,2.722,0,0,0,.714.074A10.846,10.846,0,0,0,471.4,181.522Z",
    transform: "translate(-394.271 -137.202)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510681",
    "data-name": "Path 510681",
    d: "M479.91,209.044a2.02,2.02,0,0,0,1.42.575,2.147,2.147,0,0,0,1.486-.644,2.918,2.918,0,0,0,.706-2.6,1.014,1.014,0,0,0-.164-.431.821.821,0,0,0-.049-.242,1.9,1.9,0,0,0-1.059-1.071,2.438,2.438,0,0,0-1.547-.074,2.364,2.364,0,0,0-1.588,1.933A2.984,2.984,0,0,0,479.91,209.044Z",
    transform: "translate(-401.278 -158.76)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510682",
    "data-name": "Path 510682",
    d: "M481.85,204.637c-.254-.074-.665,1.642-2.434,2.528s-3.563.254-3.633.493c-.049.1.328.431,1.1.636a4.441,4.441,0,0,0,3.009-.312,3.846,3.846,0,0,0,1.929-2.147C482.064,205.129,481.97,204.657,481.85,204.637Z",
    transform: "translate(-399.335 -158.86)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510683",
    "data-name": "Path 510683",
    d: "M489.634,154.345c.177.439,1.8.172,3.727.337s3.493.636,3.731.226c.111-.193-.176-.6-.821-1.01a6.489,6.489,0,0,0-5.681-.41C489.9,153.779,489.556,154.14,489.634,154.345Z",
    transform: "translate(-407.497 -128.431)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510684",
    "data-name": "Path 510684",
    d: "M452.6,152.423c.3.361,1.412-.066,2.767-.127s2.508.16,2.758-.238c.111-.189-.082-.558-.6-.891a4.018,4.018,0,0,0-4.454.291C452.616,151.873,452.472,152.263,452.6,152.423Z",
    transform: "translate(-385.645 -127.022)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510685",
    "data-name": "Path 510685",
    d: "M533.431,182.618c.176-.082,7.232-2.414,7.253,4.864s-7.294,5.8-7.306,5.59S533.431,182.618,533.431,182.618Z",
    transform: "translate(-433.291 -145.633)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510686",
    "data-name": "Path 510686",
    d: "M538.771,193.712c.029-.025.127.086.341.185a1.268,1.268,0,0,0,.948,0,3.14,3.14,0,0,0,1.445-2.82,4.228,4.228,0,0,0-.361-1.814,1.469,1.469,0,0,0-.956-.969.64.64,0,0,0-.747.349c-.1.205-.049.349-.09.361s-.156-.123-.1-.41a.8.8,0,0,1,.287-.456.944.944,0,0,1,.7-.189,1.786,1.786,0,0,1,1.33,1.125,4.274,4.274,0,0,1,.443,2.028c-.041,1.469-.788,2.84-1.839,3.148a1.354,1.354,0,0,1-1.162-.189C538.783,193.868,538.746,193.712,538.771,193.712Z",
    transform: "translate(-436.467 -149.018)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510687",
    "data-name": "Path 510687",
    d: "M509.778,138.943a5.52,5.52,0,0,1,3.316-1.313,16.977,16.977,0,0,1,9.235,1.5,8.1,8.1,0,0,1,3.752,3.144,4.033,4.033,0,0,1-.32,4.634,5.1,5.1,0,0,1-4.084,9.276h0a3.312,3.312,0,0,1-5.012,2.508,5.29,5.29,0,0,1-1.309-1.182c-1.392-1.786-1.531-5.172-1.149-7.388a4.843,4.843,0,0,1-3.727-1.978,9.317,9.317,0,0,1-1.642-4.006C508.477,142.313,508.489,140.232,509.778,138.943Z",
    transform: "translate(-418.704 -119.288)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510688",
    "data-name": "Path 510688",
    d: "M458.534,93.5c.5.1,12.433,3.645,14.863,12.876s1.359,11.944,1.359,11.944a5.96,5.96,0,0,1,1.194,1.17c.464.628-.464,3.423-2.024,3-11.493-6.026-25.449-7.487-41.108-8.041l-11.944-.944c-3.37.168-4.486-.8-3.021-1.547,1.125-.571,10.877-3.752,10.877-3.752l1.958-1.231,5.389-6.518s-.546-.993.714-1.7S448.736,91.471,458.534,93.5Z",
    transform: "translate(-364.813 -93.114)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633196",
    "data-name": "Group 633196",
    transform: "translate(77.553 2.892)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510689",
    "data-name": "Path 510689",
    d: "M505.373,103.715s-12.921-2.98-18.955-.558l.7-.3-5.689,2.052a3.48,3.48,0,0,1-2.951.148,25.807,25.807,0,0,1,8.714-3.94C492.781,99.643,501.5,99.43,505.373,103.715Z",
    transform: "translate(-478.48 -100.161)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510690",
    "data-name": "Path 510690",
    d: "M496.49,103.553a9.253,9.253,0,0,0-1.116-.821A16.293,16.293,0,0,0,491.962,101a19.534,19.534,0,0,0-5.541-1.174,16.332,16.332,0,0,0-6.867.854,29.58,29.58,0,0,0-3.284,1.494c-1.026.546-2.052,1.018-2.959,1.568a17.979,17.979,0,0,1-2.643,1.437,5.648,5.648,0,0,1-2.557.341c-3.214-.168-5.139-.96-4.983-1.157a.5.5,0,0,0,.242.271,4.061,4.061,0,0,0,.965.41,17.206,17.206,0,0,0,3.768.632,5.746,5.746,0,0,0,2.627-.328,17.56,17.56,0,0,0,2.676-1.433c.911-.538,1.929-1.01,2.955-1.552a29.478,29.478,0,0,1,3.255-1.482A16.18,16.18,0,0,1,486.4,100a19.476,19.476,0,0,1,5.5,1.121,17.185,17.185,0,0,1,3.415,1.662c.382.238.669.439.862.579A1.821,1.821,0,0,0,496.49,103.553Z",
    transform: "translate(-391.871 -97.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633197",
    "data-name": "Group 633197",
    transform: "translate(90.623 10.793)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510691",
    "data-name": "Path 510691",
    d: "M529.17,125.727a29.548,29.548,0,0,1-6.366-1.56c-2.463-.706-4.868-1.3-7.269-2.118-1.827-.624-3.994-1.231-5.119-2.639a2.717,2.717,0,0,0,.661,2.586,13.084,13.084,0,0,0,3.854,2.019,69.128,69.128,0,0,0,14.625,3.842,16.373,16.373,0,0,0-.386-2.13",
    transform: "translate(-510.322 -119.41)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510692",
    "data-name": "Path 510692",
    d: "M527.988,118.857c1.441.743,2.323,1.231,2.282,2.5-.033,1.055-.333,2.327-1.379,2.442a2.615,2.615,0,0,1-.952-.135l-15.946-4.326a2.43,2.43,0,0,1-1.441-.784,1.642,1.642,0,0,1,.71-2.188,4.624,4.624,0,0,1,2.508-.386,53.931,53.931,0,0,1,14.218,2.873",
    transform: "translate(-419.716 -106.59)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510693",
    "data-name": "Path 510693",
    d: "M510.621,117.853a1.494,1.494,0,0,1-.41-.731,2.052,2.052,0,0,1,.8-1.995,5.011,5.011,0,0,1,3.284-.5c1.256.152,2.713.337,4.195.579a43.329,43.329,0,0,1,7.454,1.839c.928.324,1.642.636,2.167.85l.583.254a.819.819,0,0,0,.205.078.907.907,0,0,0-.189-.111l-.566-.291c-.5-.238-1.231-.571-2.151-.915a39.536,39.536,0,0,0-7.47-1.9c-1.49-.246-2.91-.41-4.211-.566a5.1,5.1,0,0,0-3.4.575,2.1,2.1,0,0,0-.792,2.126,1.4,1.4,0,0,0,.291.571C510.556,117.816,510.617,117.862,510.621,117.853Z",
    transform: "translate(-419.552 -105.652)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510694",
    "data-name": "Path 510694",
    d: "M456.3,115.97l10.184.464-1.047,2.808-11.041-.965Z",
    transform: "translate(-386.731 -106.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510695",
    "data-name": "Path 510695",
    d: "M466.19,134.641c0-.057-4.478-1-10.028-2.118s-10.06-1.97-10.073-1.917,4.478,1,10.032,2.118S466.166,134.695,466.19,134.641Z",
    transform: "translate(-381.832 -115.216)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510696",
    "data-name": "Path 510696",
    d: "M463.61,254.013l2.873-5.188,11.07,14.161,15.429-19.045,2.258,5.808-11.969,20.938-5.077-6.883-1.207.177-4.187,7.277Z",
    transform: "translate(-392.161 -182.032)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510697",
    "data-name": "Path 510697",
    d: "M508.494,292.909a3.7,3.7,0,0,1-.328.525c-.222.332-.542.821-.924,1.42a41.244,41.244,0,0,0-2.68,4.962l-.082.176-.107-.164-.316-.5c-1.305-1.966-2.635-3.649-3.53-4.926-.456-.628-.821-1.145-1.043-1.51a3.5,3.5,0,0,1-.345-.583,4.514,4.514,0,0,1,.41.534l1.1,1.474c.928,1.231,2.278,2.906,3.587,4.889.111.172.222.341.32.5h-.185a34.939,34.939,0,0,1,2.75-4.95c.41-.6.739-1.071.981-1.387A3.589,3.589,0,0,1,508.494,292.909Z",
    transform: "translate(-413.107 -210.548)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510698",
    "data-name": "Path 510698",
    d: "M549.148,163.47a1.366,1.366,0,0,1,.292.312,4.926,4.926,0,0,1,.6,1,5.677,5.677,0,0,1-1.757,6.978,4.959,4.959,0,0,1-1.006.591,1.355,1.355,0,0,1-.41.14,11.223,11.223,0,0,0,1.318-.85,5.746,5.746,0,0,0,1.712-6.781,11.071,11.071,0,0,0-.751-1.391Z",
    transform: "translate(-441.246 -134.592)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510699",
    "data-name": "Path 510699",
    d: "M477.17,279.053a.341.341,0,0,1-.053.148l-.185.41c-.168.365-.41.895-.763,1.556a51.042,51.042,0,0,1-3.1,5.2l-.082.168-.078-.144-2.549-4.716c-1.79-3.341-3.407-6.366-4.589-8.587-.571-1.084-1.034-1.974-1.371-2.611l-.361-.718a1.567,1.567,0,0,1-.115-.255,1.338,1.338,0,0,1,.152.234l.41.7,1.428,2.582,4.609,8.538c.895,1.675,1.753,3.284,2.533,4.724h-.168a58.352,58.352,0,0,0,3.161-5.151l.821-1.527.213-.41A.616.616,0,0,1,477.17,279.053Z",
    transform: "translate(-392.344 -197.106)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510700",
    "data-name": "Path 510700",
    d: "M354.038,351.46l-5.907,16.927-8.85-10.294L327.51,365.4l14.978,20.035c4.055,5.779,10.746,7.594,14.4,6.719,7.454-1.777,11.423-11.427,11.423-11.427l-.045-9.244-1.589-13.709Z",
    transform: "translate(-311.925 -245.419)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510701",
    "data-name": "Path 510701",
    d: "M392.68,309.1s22.744,24.71,27.411,29.237a52.729,52.729,0,0,0,6.929,5.057l-7.052.821Z",
    transform: "translate(-350.345 -220.446)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633198",
    "data-name": "Group 633198",
    transform: "translate(35.489 125.505)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510702",
    "data-name": "Path 510702",
    d: "M376,398.929a115.431,115.431,0,0,0,15.688,2.52c6.362.349,22.986.242,22.986.242l-3.284-2.812Z",
    transform: "translate(-376 -398.88)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510703",
    "data-name": "Path 510703",
    d: "M330.315,299.907l-40.775-1,35.472,41.1,37.635,1.026Z",
    transform: "translate(-289.54 -214.439)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510704",
    "data-name": "Path 510704",
    d: "M325.45,335.8a1.892,1.892,0,0,0-2.052-1.9c-.6.045-1.383.119-2.348.25-2.487.332-9.777,4.215-9.925,5.693-.218,2.167.9,2.964.9,2.964s-1.383,1.962-.8,3.53c.5,1.342,2.689,1.736,2.689,1.736s-1.547,1.929.16,3.21c.6.443,1.786,1.293,2.052,1.584a5.281,5.281,0,0,0,.493,1.141,4.4,4.4,0,0,0,3.239,1.72l.41.025a3.206,3.206,0,0,0,2.216-.718c2.82-2.311,10.791-8.989,10.9-10.771,0,0,1.519-1.268.858-2.52s-2.964-.62-2.964-.62a1.909,1.909,0,0,0,.517-2.212c-.583-1.318-4.708-1.063-6.567-.755-1.486.242-5.632,1.059-5.632,1.059s5.484-2.085,5.779-3.042A1.617,1.617,0,0,0,325.45,335.8Z",
    transform: "translate(-302.242 -235.063)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510705",
    "data-name": "Path 510705",
    d: "M343.629,359.16a4.132,4.132,0,0,1-.55.357c-.357.218-.887.521-1.552.874-1.322.714-3.2,1.617-5.311,2.512s-4.059,1.642-5.476,2.13c-.706.25-1.281.447-1.683.575a3.314,3.314,0,0,1-.628.181,4.2,4.2,0,0,1,.6-.255l1.642-.64c1.4-.538,3.337-1.285,5.447-2.18s3.986-1.773,5.336-2.463c.669-.337,1.207-.62,1.58-.821A3.772,3.772,0,0,1,343.629,359.16Z",
    transform: "translate(-312.467 -249.958)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510706",
    "data-name": "Path 510706",
    d: "M339.747,351.37a3.808,3.808,0,0,1-.6.148c-.386.09-.952.213-1.642.41-1.379.349-3.259.94-5.311,1.662-1.026.361-2.015.686-2.873,1.026s-1.642.685-2.3.985-1.157.566-1.51.747a3.773,3.773,0,0,1-.558.275.664.664,0,0,1,.127-.1c.086-.057.218-.144.39-.246.345-.205.85-.488,1.49-.821s1.412-.677,2.29-1.03,1.863-.681,2.873-1.047a51.659,51.659,0,0,1,5.336-1.6c.7-.164,1.268-.267,1.662-.332A3.352,3.352,0,0,1,339.747,351.37Z",
    transform: "translate(-310.416 -245.366)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510707",
    "data-name": "Path 510707",
    d: "M322.967,346.86a4.515,4.515,0,0,1-.874.5c-.558.283-1.342.64-2.2,1.03s-1.642.768-2.192,1.051a6.027,6.027,0,0,1-.907.439,4.045,4.045,0,0,1,.821-.566,23.161,23.161,0,0,1,2.175-1.108c.866-.41,1.642-.731,2.225-.977A5.189,5.189,0,0,1,322.967,346.86Z",
    transform: "translate(-305.605 -242.707)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510708",
    "data-name": "Path 510708",
    d: "M342.446,367.28a2.744,2.744,0,0,1-.369.443c-.25.279-.624.669-1.1,1.133-.948.94-2.344,2.143-3.842,3.509-.374.341-.727.694-1.1,1.006a13.2,13.2,0,0,1-1.112.841,7.557,7.557,0,0,1-2.126,1.01,4.761,4.761,0,0,1-1.572.2,2.83,2.83,0,0,1-.41-.045q-.148-.025-.148-.037a4.2,4.2,0,0,1,.579,0,5.1,5.1,0,0,0,1.531-.254,7.857,7.857,0,0,0,2.052-1.03,13.443,13.443,0,0,0,1.084-.821c.361-.308.71-.661,1.088-1.006,1.5-1.371,2.91-2.553,3.883-3.46.488-.452.874-.821,1.141-1.084A3.339,3.339,0,0,1,342.446,367.28Z",
    transform: "translate(-313.788 -254.745)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510709",
    "data-name": "Path 510709",
    d: "M334.03,297.55l-17.9-.226a.41.41,0,0,0-.332.71l3.9,4.564,17.65.534a.41.41,0,0,0,.353-.677l-3.341-4.724A.41.41,0,0,0,334.03,297.55Z",
    transform: "translate(-304.941 -213.502)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510710",
    "data-name": "Path 510710",
    d: "M319.365,302.514l-3.957-4.63a.624.624,0,0,1,.484-1.034l17.9.226a.628.628,0,0,1,.5.263l3.341,4.724a.628.628,0,0,1-.513.989ZM333.8,297.47h0l-17.9-.226a.234.234,0,0,0-.181.386l3.842,4.495,17.576.534a.218.218,0,0,0,.2-.127.226.226,0,0,0,0-.242l-3.337-4.72A.242.242,0,0,0,333.8,297.47Z",
    transform: "translate(-304.7 -213.224)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510711",
    "data-name": "Path 510711",
    d: "M385.423,403.87a18.836,18.836,0,0,0,.029-2.319,10.479,10.479,0,0,0-6.058-8.755A17.594,17.594,0,0,0,377.21,392a.708.708,0,0,1,.164,0c.1.021.259.037.456.09a9.577,9.577,0,0,1,1.642.546,10.261,10.261,0,0,1,6.157,8.882,9.176,9.176,0,0,1-.057,1.716,4.489,4.489,0,0,1-.078.46A.652.652,0,0,1,385.423,403.87Z",
    transform: "translate(-341.225 -269.318)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510712",
    "data-name": "Path 510712",
    d: "M545.06,326.961s8.932,22.12,12.983,30.1c4.2,8.271,10.434,22.128,22.937,14.883,10.225-5.927.961-37.052.961-37.052l-9.2,4.158L559.127,317.27Z",
    transform: "translate(-440.179 -225.263)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510713",
    "data-name": "Path 510713",
    d: "M529.923,252.967a1.166,1.166,0,0,0-1.609-.69,4.805,4.805,0,0,0-2.672,3.965c-.513,3.789.193,6.465-.694,7.454s-12.026,1.781-12.888,3.407-.341,2.984-.378,3.784a1.174,1.174,0,0,1-.337.763,2.485,2.485,0,0,0-.542,3.091,1.2,1.2,0,0,1,.045,1.149,2.431,2.431,0,0,0,.562,2.968,1.189,1.189,0,0,1,.259.378c.337.78,1.642,3.55,3.493,4.1a13.866,13.866,0,0,0,4.277.464,1.158,1.158,0,0,1,.8.283c.94.821,4.059,2.812,4.983,4.018,0,0,11.493-8.037,12.219-8.414,0,0-5.18-7.906-5.443-11.53-.275-3.867-2.709-8.369-2.052-11.994A6.676,6.676,0,0,0,529.923,252.967Z",
    transform: "translate(-419.784 -186.88)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510714",
    "data-name": "Path 510714",
    d: "M545.06,326.761s0-.021.062-.053l.193-.148.768-.546,2.894-2.028,10.093-7,.082-.057.057.086c1.482,2.278,3.087,4.782,4.741,7.388l9.687,15.54c1.231,1.974,2.249,3.575,2.955,4.692l.821,1.281.205.332a.558.558,0,0,1,.062.119,1.146,1.146,0,0,1-.078-.107l-.222-.324c-.2-.3-.48-.718-.821-1.256-.718-1.092-1.753-2.68-3.013-4.655-2.528-3.94-5.931-9.441-9.74-15.491-1.642-2.623-3.255-5.131-4.729-7.413l.14.029-10.134,6.937-2.927,1.978-.784.521-.205.131Z",
    transform: "translate(-440.179 -225.062)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510715",
    "data-name": "Path 510715",
    d: "M627.763,388.009a1.955,1.955,0,0,1-.222-.369c-.152-.287-.332-.628-.542-1.03a18.287,18.287,0,0,0-2.052-3.218,8.275,8.275,0,0,0-3-2.294,10.631,10.631,0,0,0-1.51-.46,1.33,1.33,0,0,1,.431.021,5.283,5.283,0,0,1,1.137.3,7.843,7.843,0,0,1,3.1,2.294,15.718,15.718,0,0,1,2.052,3.284c.213.443.374.821.48,1.063A1.539,1.539,0,0,1,627.763,388.009Z",
    transform: "translate(-484.618 -262.615)",
    fill: "#263238"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProjects);
export default __webpack_public_path__ + "static/media/EmptyProjects.e79004b88a47ff6e354e3d3488154b96.svg";
export { ForwardRef as ReactComponent };